(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[229],{

/***/ 38862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home",
      function () {
        return __webpack_require__(70266);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ withLogin; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/organisms/LoadingScreen/index.js
var LoadingScreen = __webpack_require__(37071);
// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var NotifyUtils = __webpack_require__(25872);
// EXTERNAL MODULE: ./src/utils/SessionUtils.js
var SessionUtils = __webpack_require__(69702);
;// CONCATENATED MODULE: ./src/HOC/withLogin.js
// TODO: refactor contanst






function withLogin(Component) {
    var checkLogin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, redirect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function WithLoginHOC(_param) {
        var err = _param.err, props = (0,_object_without_properties/* default */.Z)(_param, [
            "err"
        ]);
        // if (maintain) {
        //   return <MaintainPage />;
        // }
        // nếu có lỗi server side thì sẽ in ở đây
        if (err) {
            console.error(err);
        }
        var url = redirect.url, message = redirect.message;
        var isAuthenticated = props.isAuthenticated, isInvalidToken = props.isInvalidToken;
        var msg = "";
        if (checkLogin && !isAuthenticated) {
            msg = message && message.length > 0 ? message : "Bạn cần đăng nhập để v\xe0o được trang n\xe0y ";
        } else if (isInvalidToken) {
            // server side
            // when user click other page , do with server side run -> check inValidToken
            msg = message && message.length > 0 ? message : "Phi\xean l\xe0m việc của bạn đ\xe3 hết hạn, vui l\xf2ng đăng nhập lại để c\xf3 thể tiếp tục thao t\xe1c ";
        }
        if (msg && msg.length > 0) {
            (0,SessionUtils/* removeSessionToken */.t)();
            NotifyUtils/* default.error */.Z.error(msg);
            setTimeout(function() {
                var redirectUrl = window.location.pathname + window.location.search;
                window.location.replace(url && url.length > 0 ? url : "/home?login=true&redirectUrl=".concat(encodeURIComponent(redirectUrl)));
            }, 2000);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen/* default */.Z, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props));
    };
}

;// CONCATENATED MODULE: ./src/HOC/index.js



/***/ }),

/***/ 34175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PlayIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var PlayIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.006 11.0818C16.5418 11.5767 16.5418 12.4233 16.006 12.9182L11.5982 16.99C10.7976 17.7295 9.5 17.1617 9.5 16.0718V7.9282C9.5 6.83829 10.7976 6.27045 11.5982 7.01001L16.006 11.0818Z",
                fill: "#005C29"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "23",
                height: "23",
                rx: "11.5",
                stroke: "#005C29"
            })
        ]
    });
});


/***/ }),

/***/ 36807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4024);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95477);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96517);
/* harmony import */ var clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59261);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90512);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13270);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43931);
/* harmony import */ var utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25872);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50645);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);













var ARR_STAR = [
    0,
    1,
    2,
    3,
    4
];
var ImageContainer = function(param) {
    var indexActive = param.indexActive, index = param.index, onMouseOver = param.onMouseOver, rating = param.rating, onClick = param.onClick;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().wrapperImage),
        onMouseOver: function() {
            return onMouseOver(index);
        },
        onFocus: function() {
            return onMouseOver(index);
        },
        onClick: function() {
            return onClick(index);
        },
        role: "button",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_4__/* .ImageFallbackStatic */ .ez, {
            src: indexActive > index - 1 || rating > index - 1 ? constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .STAR_FULFILLED */ .ACS : constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .STAR_OUTLINE */ .C_G,
            width: "44",
            height: "44"
        })
    });
};
var ModalRating = function(param) {
    var _open = param.open, open = _open === void 0 ? false : _open, onClose = param.onClose, className = param.className, configData = param.configData;
    var _customerRatingConfig = configData.customerRatingConfig, customerRatingConfig = _customerRatingConfig === void 0 ? {} : _customerRatingConfig, _customerID = configData.customerID, customerID = _customerID === void 0 ? 0 : _customerID;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true), enable = ref[0], setEnable = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(4), index = ref3[0], setIndex = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(4), rating = ref4[0], setRating = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), content = ref5[0], setContent = ref5[1];
    var handleMouseOver = function(index) {
        setIndex(index);
    };
    var handleMouseOut = function(e) {
        e.stopPropagation();
        setIndex(-1);
    };
    var onValueChange = function(e) {
        var value = ((e === null || e === void 0 ? void 0 : e.target) || "").value;
        setContent(function() {
            return value;
        });
        var conditionHaveValueAndRating = value && rating > -1;
        if (conditionHaveValueAndRating) {
            setEnable(true);
            setError(false);
            return;
        }
        if (rating < 2) {
            setEnable(false);
            setError(true);
        }
    };
    var handleClick = function(index) {
        if (index > 1 || content) {
            setEnable(true);
            setError(false);
        } else {
            setEnable(false);
            setError(true);
        }
        setRating(function() {
            return index;
        });
    };
    var handleSubmitRating = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var body, _tmp, submitRating, _tmp1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((content === null || content === void 0 ? void 0 : content.trim()) || rating > 1)) return [
                            3,
                            2
                        ];
                        setLoading(true);
                        _tmp = {};
                        body = (_tmp.customerID = customerID, _tmp.type = "ORDER", _tmp.point = rating + 1, _tmp.feedback = (content === null || content === void 0 ? void 0 : content.trim()) || "", _tmp);
                        _tmp1 = {};
                        return [
                            4,
                            (0,clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__/* .postRating */ ._G)((_tmp1.body = body, _tmp1))
                        ];
                    case 1:
                        submitRating = _state.sent();
                        if (submitRating) {
                            setLoading(false);
                            if ((submitRating === null || submitRating === void 0 ? void 0 : submitRating.status) !== "OK") {
                                utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].error */ .Z.error(submitRating === null || submitRating === void 0 ? void 0 : submitRating.message);
                            } else {
                                utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].success */ .Z.success("Cảm ơn bạn đ\xe3 đ\xe1nh gi\xe1");
                                onClose();
                            }
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setError(true);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitRating() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        localStorage.setItem("time-rating", new Date());
        onClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal), className),
        open: open,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().containerModal),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().title),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_4__/* .ImageFallbackStatic */ .ez, {
                            src: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .ICON_RATING */ .kvI,
                            width: "60",
                            height: "60",
                            objectFit: "contain"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: (customerRatingConfig === null || customerRatingConfig === void 0 ? void 0 : customerRatingConfig.ratingTitle) || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().body),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().titleBody),
                            dangerouslySetInnerHTML: {
                                __html: (customerRatingConfig === null || customerRatingConfig === void 0 ? void 0 : customerRatingConfig.ratingSubTitle) || ""
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().ratingContainer),
                            onMouseOut: handleMouseOut,
                            onBlur: handleMouseOut,
                            role: "button",
                            children: ARR_STAR === null || ARR_STAR === void 0 ? void 0 : ARR_STAR.map(function(x) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageContainer, {
                                    onMouseOver: handleMouseOver,
                                    onMouseOut: handleMouseOut,
                                    onClick: handleClick,
                                    index: x,
                                    indexActive: index,
                                    rating: rating
                                }, x);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().textarea), error && ((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().error))),
                            onChange: onValueChange,
                            value: content,
                            placeholder: (customerRatingConfig === null || customerRatingConfig === void 0 ? void 0 : customerRatingConfig.ratingPlaceholder) || ""
                        }),
                        error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().errorMessage),
                            children: "Vui l\xf2ng đ\xe1nh gi\xe1 để ho\xe0n tất"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().groupButton),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().skipButton),
                            onClick: handleClose,
                            children: "Bỏ qua"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().disabled), enable && !loading && ((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().submit))),
                            onClick: handleSubmitRating,
                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                size: 24,
                                color: "inherit"
                            }) : "  Ho\xe0n Tất"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalRating);


/***/ }),

/***/ 65397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4024);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64436);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90512);
/* harmony import */ var _index_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26205);
/* harmony import */ var _index_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_css__WEBPACK_IMPORTED_MODULE_3__);






var ConfirmUI = function(param) {
    var children = param.children, classes = param.classes, onNext = param.onNext, onClose = param.onClose, buttonNext = param.buttonNext, buttonClose = param.buttonClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_index_module_css__WEBPACK_IMPORTED_MODULE_3___default().ConfirmUI), classes),
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                fullWidth: true,
                children: [
                    buttonNext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (_index_module_css__WEBPACK_IMPORTED_MODULE_3___default().accountCreationForm_button),
                        onClick: onNext,
                        children: buttonNext
                    }),
                    buttonClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "outlined",
                        type: "submit",
                        className: (_index_module_css__WEBPACK_IMPORTED_MODULE_3___default().btnOutlined),
                        onClick: onClose,
                        children: buttonClose
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmUI);


/***/ }),

/***/ 78022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModalLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_atoms_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57925);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69467);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);







function ModalLayout(_param) {
    var width = _param.width, onClose = _param.onClose, visible = _param.visible, height = _param.height, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "width",
        "onClose",
        "visible",
        "height",
        "children"
    ]);
    var handleClose = function(_, reason) {
        var modalCloseKeys = [
            "backdropClick",
            "escapeKeyDown"
        ];
        if (!modalCloseKeys.includes(reason)) {
            onClose();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        open: !!visible,
        onClose: handleClose
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().auth_modal_content),
            style: {
                width: "".concat(width),
                height: "".concat(height)
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().auth_modal_body),
                children: children
            })
        })
    }));
};


/***/ }),

/***/ 90055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JB": function() { return /* binding */ ConfirmType; },
/* harmony export */   "Zs": function() { return /* binding */ ConfirmText; },
/* harmony export */   "py": function() { return /* binding */ LICENSE_PAGE_URL; }
/* harmony export */ });
// Giấy tờ nộp ở trang tài khoản, không còn chụp ngay trong luồng đăng ký.
var LICENSE_PAGE_URL = "/my-account?tab=3";
var ConfirmType;
(function(ConfirmType) {
    ConfirmType["Selection"] = "Selection";
    ConfirmType["Close"] = "Close";
})(ConfirmType || (ConfirmType = {}));
var ConfirmText;
(function(ConfirmText) {
    ConfirmText["Selection"] = "K\xedch hoạt ngay";
    ConfirmText["Close"] = "Tiếp tục x\xe1c thực";
})(ConfirmText || (ConfirmText = {}));


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ListProductForPCWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19238);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var ListProductForPCWrapper = function(param) {
    var children = param.children, _gap = param.gap, gap = _gap === void 0 ? "20px" : _gap;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: gap,
        justifyContent: "center",
        children: children
    });
};


/***/ }),

/***/ 32838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_ListProductWithTitle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/assets/svg/PlayIcon.jsx
var PlayIcon = __webpack_require__(34175);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
;// CONCATENATED MODULE: ./src/constants/Enums/product.ts
var EnumProductGA;
(function(EnumProductGA) {
    EnumProductGA["SAME_MANUFACTURER"] = "SAME_MANUFACTURER";
    EnumProductGA["SAME_INGREDIENT"] = "SAME_INGREDIENT";
})(EnumProductGA || (EnumProductGA = {}));

// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/zustand-lib/useStartGuide.js
var useStartGuide = __webpack_require__(68373);
// EXTERNAL MODULE: ./src/components/mocules/ListProductWithTitle/ListProductForPCWrapper.tsx
var ListProductForPCWrapper = __webpack_require__(1510);
// EXTERNAL MODULE: ./src/components/mocules/ListProductWithTitle/styles.module.css
var styles_module = __webpack_require__(99867);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ListProductWithTitle/index.js























var MEGA_SALE = "MEGA-SALE";
var ListProductWithTitle = function(param) {
    var children = param.children, _name = param.name, name = _name === void 0 ? "" : _name, redirect = param.redirect, viewMore = param.viewMore, _viewMoreInTitle = param.viewMoreInTitle, viewMoreInTitle = _viewMoreInTitle === void 0 ? true : _viewMoreInTitle, _page = param.page, page = _page === void 0 ? null : _page, icon = param.icon, iconWidth = param.iconWidth, iconHeight = param.iconHeight, _isBestProducts = param.isBestProducts, isBestProducts = _isBestProducts === void 0 ? false : _isBestProducts, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _type = param.type, type = _type === void 0 ? "" : _type, productsType = param.productsType, gap = param.gap, _forceShowButtonAtBottom = param.forceShowButtonAtBottom, forceShowButtonAtBottom = _forceShowButtonAtBottom === void 0 ? false : _forceShowButtonAtBottom, backgroundImage = param.backgroundImage, _config = param.config, config = _config === void 0 ? {} : _config;
    var isGuide = (0,useStartGuide/* default */.Z)(function(state) {
        return state;
    }).isGuide;
    var ref = (0,react.useRef)(null);
    var ctaBottomRef = (0,react.useRef)(null);
    var TITLE_ICON = name === "Sản phẩm c\xf9ng nh\xe0 b\xe1n h\xe0ng" ? Images/* SAME_STORE */.T2Q : Images/* SAME_INGREDIENT */.cau;
    var router = (0,next_router.useRouter)();
    var currentUrl = router.asPath;
    var wrapperRef = (0,react.useRef)(null);
    var isShowBtnAtBottom = viewMore && productsType === MEGA_SALE || forceShowButtonAtBottom;
    var defaultConfigCtaText = (config === null || config === void 0 ? void 0 : config.ctaText) || "Xem tất cả";
    var ctaText = config ? defaultConfigCtaText : data/* MAP_BTN_TITLE_BY_REDIRECT_URL */.Wg[redirect] || "Xem tất cả";
    var backgroundCta = (config === null || config === void 0 ? void 0 : config.backgroundCta) || "linear-gradient(0deg, #078c4e 0%, #29cc80 100%)";
    var ctaTextColor = config === null || config === void 0 ? void 0 : config.ctaTextColor;
    var headerImage = config === null || config === void 0 ? void 0 : config.headerImage;
    var handleGA = function() {
        if (type === EnumProductGA.SAME_MANUFACTURER) {
            gtag/* default.clickViewAllProductSameManufacturer */.ZP.clickViewAllProductSameManufacturer();
        }
        if (type === EnumProductGA.SAME_INGREDIENT) {
            gtag/* default.clickViewAllProductSameIngredient */.ZP.clickViewAllProductSameIngredient();
        }
    };
    (0,react.useEffect)(function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            if (isGuide) {
                ref.current.slickPause();
            } else {
                ref.current.slickPlay();
            }
        }
    }, [
        isGuide
    ]);
    // This effect to make ctaTextColorConfig with the highest priority (!important css)
    (0,react.useEffect)(function() {
        if ((ctaBottomRef === null || ctaBottomRef === void 0 ? void 0 : ctaBottomRef.current) && ctaTextColor) {
            ctaBottomRef.current.style.color = ctaTextColor;
        }
    }, []);
    return page === "PRD_DETAIL" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        ref: wrapperRef,
        className: (0,clsx/* default */.Z)((styles_module_default()).wrapper, isBestProducts && (styles_module_default()).bestProductsWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).icon_name, isBestProducts && (styles_module_default()).bestProducts),
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                        src: icon,
                        width: iconWidth || 40,
                        height: iconHeight || 40,
                        alt: "icon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: (0,clsx/* default */.Z)((styles_module_default()).name, isBestProducts && (styles_module_default()).bestProductsName),
                        children: name
                    }),
                    isBestProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (styles_module_default()).bestProducts_view_more,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "".concat(redirect),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Xem tất cả"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    src: Images/* DOUBLE_ARROW_ICON */.uVr,
                                    width: 12,
                                    height: 12,
                                    alt: "icon"
                                })
                            ]
                        })
                    })
                ]
            }),
            isBestProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductForPCWrapper/* ListProductForPCWrapper */.r, {
                gap: gap,
                children: children
            }),
            !isBestProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductForPCWrapper/* ListProductForPCWrapper */.r, {
                gap: gap,
                children: children
            }),
            viewMore && !isBestProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).view_more),
                onClick: handleGA,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                    href: "".concat(redirect),
                    color: "#0E1983",
                    name: "Xem tất cả"
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (loading || (children === null || children === void 0 ? void 0 : children.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)((styles_module_default()).wrapper_media, productsType === MEGA_SALE && (styles_module_default()).wrapperMega),
            ref: wrapperRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).wrapper_media_container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)((styles_module_default()).SliderProductWrap, productsType === MEGA_SALE && (styles_module_default()).backgroundMega),
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, backgroundImage ? {
                        backgroundImage: "url('" + backgroundImage + "')"
                    } : {}), {
                        backgroundSize: "100% 100%"
                    }),
                    children: [
                        productsType === MEGA_SALE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: headerImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* default */.ZP, {
                                src: headerImage,
                                width: 1180,
                                height: 74,
                                layout: "intrinsic",
                                alt: "header-image-mega-block"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).wrapperTitle,
                            style: {
                                visibility: name == "" ? "hidden" : "visible"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: (0,clsx/* default */.Z)((styles_module_default()).title, (styles_module_default()).wrapperContentTitle),
                                    children: [
                                        icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (styles_module_default()).contentTitle,
                                            children: name
                                        })
                                    ]
                                }),
                                viewMoreInTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (styles_module_default()).seeAllWrapper,
                                    onClick: function() {
                                        if (productsType === "THUOC_KE_DON_GIA_TOT") {
                                            gtag/* default.clickViewAllThuocKeDonGiaTot */.ZP.clickViewAllThuocKeDonGiaTot({
                                                currentUrl: currentUrl,
                                                redirect: redirect
                                            });
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                                        href: "".concat(redirect),
                                        className: (0,clsx/* default */.Z)((styles_module_default()).seeAll),
                                        children: [
                                            data/* MAP_BTN_TITLE_BY_REDIRECT_URL */.Wg[redirect] || "Xem tất cả",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* PlayIcon */.o, {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (styles_module_default()).progress,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 50,
                                thickness: 4
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            className: productsType === MEGA_SALE && "px-[6px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductForPCWrapper/* ListProductForPCWrapper */.r, {
                                    gap: gap,
                                    children: children
                                }),
                                isShowBtnAtBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (styles_module_default()).seeAllWrapperMega,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                        href: "".concat(redirect),
                                        className: (0,clsx/* default */.Z)((styles_module_default()).seeAll),
                                        style: {
                                            background: backgroundCta,
                                            color: "".concat(ctaTextColor)
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            ref: ctaBottomRef,
                                            children: ctaText
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var mocules_ListProductWithTitle = (ListProductWithTitle);


/***/ }),

/***/ 2546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58365);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26123);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);






var SliderProductBlock = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var _hiddenTitle = param.hiddenTitle, hiddenTitle = _hiddenTitle === void 0 ? false : _hiddenTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().sliderProductBlockWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                marginTop: hiddenTitle ? 0 : 40,
                marginBottom: hiddenTitle ? 40 : 0
            },
            children: [
                !hiddenTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    width: "100%",
                    height: 70
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().sliderWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        })
                    ]
                })
            ]
        })
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (SliderProductBlock);


/***/ }),

/***/ 34414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MiniBannerBlock; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19238);
/* harmony import */ var constants_Enums_mini_banner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38020);
/* harmony import */ var hooks_useOnScreen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97429);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43931);
/* harmony import */ var utils_debounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74118);
/* harmony import */ var utils_gtag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57059);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5178);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var context_Auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95581);
/* harmony import */ var services_WebService__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98682);













function MiniBannerBlock(param) {
    var _defaultMiniBanners = param.defaultMiniBanners, defaultMiniBanners = _defaultMiniBanners === void 0 ? [] : _defaultMiniBanners;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultMiniBanners), miniBanners = ref[0], setMiniBanners = ref[1];
    var user = (0,context_Auth__WEBPACK_IMPORTED_MODULE_7__/* .useAuth */ .aC)().user;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var banners, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,services_WebService__WEBPACK_IMPORTED_MODULE_8__/* .getMiniBanners */ .ad)((_tmp.user = user, _tmp))
                        ];
                    case 1:
                        banners = _state.sent();
                        setMiniBanners(banners);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        user === null || user === void 0 ? void 0 : user.provinceCode,
        user === null || user === void 0 ? void 0 : user.customerID
    ]);
    var isBannerSize4 = (miniBanners === null || miniBanners === void 0 ? void 0 : miniBanners.length) === constants_Enums_mini_banner__WEBPACK_IMPORTED_MODULE_1__/* .ENUMS_MINI_BANNER_IMAGE_LAYOUT.MINI_BANNERS_SIZE_4.quantity */ .J.MINI_BANNERS_SIZE_4.quantity;
    var bannerRefs = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)([]);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var visible = (0,hooks_useOnScreen__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(wrapperRef);
    var getVisibleElements = function(eventRefs) {
        var elements = eventRefs.current;
        var visible = [];
        elements === null || elements === void 0 ? void 0 : elements.forEach(function(element, index) {
            var rect = element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
            var isVisible = rect.left >= 0 && rect.right <= window.innerWidth;
            if (isVisible) {
                visible.push(index);
            }
        });
        return visible;
    };
    var executeAfterDebounce = function(visibleElements) {
        visibleElements.forEach(function(element) {
            utils_gtag__WEBPACK_IMPORTED_MODULE_6__/* ["default"].showMiniBanner */ .ZP.showMiniBanner({
                link: miniBanners[element],
                total: miniBanners.length
            });
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (visible) {
            var visibleElements = getVisibleElements(bannerRefs);
            (0,utils_debounce__WEBPACK_IMPORTED_MODULE_5__/* .debounceFunc300 */ .V9)(function() {
                executeAfterDebounce(visibleElements);
            });
        }
    }, [
        visible
    ]);
    if (!(miniBanners === null || miniBanners === void 0 ? void 0 : miniBanners.length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default().miniBannerBlockWrapper),
        ref: wrapperRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default().gridImagesWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default().gridImages),
                children: miniBanners.map(function(banner, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        ref: function(el) {
                            bannerRefs.current[index] = el;
                        },
                        onClick: function() {
                            utils_gtag__WEBPACK_IMPORTED_MODULE_6__/* ["default"].clickMiniBanner */ .ZP.clickMiniBanner({
                                link: banner,
                                total: miniBanners.length
                            });
                        },
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_11___default())["".concat(isBannerSize4 ? "miniBannerImageSize4" : "miniBannerImageSize5", "_").concat(index + 1)],
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: (banner === null || banner === void 0 ? void 0 : banner.url) || "/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (banner === null || banner === void 0 ? void 0 : banner.imageURL) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_4__/* .ImageFallbackBanner */ .Up, {
                                src: banner.imageURL,
                                layout: "fill",
                                objectFit: "cover",
                                width: 1500
                            })
                        })
                    }, banner.imageURL);
                })
            })
        })
    });
};


/***/ }),

/***/ 56856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useGetProductsDisplayedFromAppSettings; }
/* harmony export */ });
/* harmony import */ var constants_Enums_app_settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73796);
/* harmony import */ var zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31439);


var DEFAULT_PRODUCTS_DISPLAYED = 10;
var useGetProductsDisplayedFromAppSettings = function(key) {
    var appSetting = (0,zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_1__/* .useStore */ .oR)(function(state) {
        return state.appSetting;
    });
    var productsDisplayed = appSetting[constants_Enums_app_settings__WEBPACK_IMPORTED_MODULE_0__/* .EnumAppSettings.PRODUCTS_DISPLAYED */ .nv.PRODUCTS_DISPLAYED] || null;
    return (productsDisplayed === null || productsDisplayed === void 0 ? void 0 : productsDisplayed[key]) || DEFAULT_PRODUCTS_DISPLAYED;
};


/***/ }),

/***/ 97429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOnScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/rules-of-hooks */ 

function useOnScreen(ref) {
    var isActive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (!IntersectionObserver) {
        return false;
    }
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isIntersecting = _$ref[0], setIsIntersecting = _$ref[1];
    var options = {
        threshold: 0.8
    };
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            return setIsIntersecting(entry.isIntersecting);
        }, options);
    }, []);
    var onScroll = function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            observer.observe(ref.current);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isActive) {
            return function() {
                observer.disconnect();
            };
        }
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            observer.observe(ref.current);
        }
        document.addEventListener("scroll", onScroll, true);
        document.addEventListener("touchmove", onScroll, true);
        return function() {
            observer.disconnect();
            document.removeEventListener("scroll", onScroll, true);
            document.removeEventListener("touchmove", onScroll, true);
        };
    }, [
        ref,
        observer
    ]);
    return isIntersecting;
};


/***/ }),

/***/ 70266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/HOC/index.js + 1 modules
var HOC = __webpack_require__(51447);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@thuocsi/customer-live-chat/src/utils/common.js
var common = __webpack_require__(44311);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
// EXTERNAL MODULE: ./src/clients/CustomerClient.js
var CustomerClient = __webpack_require__(59261);
// EXTERNAL MODULE: ./src/clients/PromoClient.js
var PromoClient = __webpack_require__(46128);
// EXTERNAL MODULE: ./src/clients/VideoClient.js
var VideoClient = __webpack_require__(1002);
// EXTERNAL MODULE: ./src/clients/WebServiceClient.js
var WebServiceClient = __webpack_require__(91952);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/NavigateBefore.js
var NavigateBefore = __webpack_require__(18042);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/NavigateNext.js
var NavigateNext = __webpack_require__(98121);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./src/hooks/useOnScreen.js
var useOnScreen = __webpack_require__(97429);
// EXTERNAL MODULE: ./src/hooks/useProvinces.js
var useProvinces = __webpack_require__(86853);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var utils_ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 2 modules
var storeGlobal = __webpack_require__(31439);
// EXTERNAL MODULE: ./src/components-v2/mocules/BannerSliderNew/styles.module.css
var styles_module = __webpack_require__(79820);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/BannerSliderNew/index.js



















function SampleNextArrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        onClick: onClick,
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigateNext/* default */.Z, {})
    });
}
function SamplePrevArrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        onClick: onClick,
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigateBefore/* default */.Z, {})
    });
}
// "Thành phố Hồ Chí Minh" -> "TP.HỒ CHÍ MINH" cho khớp layout banner
var formatProvinceName = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return name.replace(/^Thành phố\s*/i, "TP.").replace(/^Tỉnh\s*/i, "").trim().toUpperCase();
};
// in-use
var BannerSliderNew = function() {
    var settingsSliderBanner = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        rows: 1,
        swipeToSlide: true,
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dotsClass: (styles_module_default()).dots,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SamplePrevArrow, {})
    };
    var banners = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.banners;
    });
    var ref = (0,react.useState)([]), infoBanner = ref[0], setInfoBanner = ref[1];
    // text tên tỉnh của khách hàng, đè lên banner có bật showProvinceName
    var hasProvinceBanner = infoBanner.some(function(banner) {
        return banner === null || banner === void 0 ? void 0 : banner.showProvinceName;
    });
    var ref1 = (0,Auth/* useAuth */.aC)(), user = ref1.user, customerInfo = ref1.customerInfo;
    var provinceCode = (user === null || user === void 0 ? void 0 : user.provinceCode) || (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.provinceCode);
    var getProvinceByCode = (0,useProvinces/* useProvinces */.L)().getProvinceByCode;
    var ref2 = (0,react.useState)(""), provinceName = ref2[0], setProvinceName = ref2[1];
    (0,react.useEffect)(function() {
        if (!hasProvinceBanner || !provinceCode) {
            setProvinceName("");
            return;
        }
        getProvinceByCode(provinceCode).then(function(province) {
            return setProvinceName(formatProvinceName(province === null || province === void 0 ? void 0 : province.name));
        });
    }, [
        hasProvinceBanner,
        provinceCode
    ]);
    (0,react.useLayoutEffect)(function() {
        setInfoBanner(banners);
    }, [
        banners
    ]);
    var ref3 = (0,react.useRef)({});
    var wrapperRef = (0,react.useRef)();
    var visible = (0,useOnScreen/* default */.Z)(wrapperRef);
    var router = (0,next_router.useRouter)();
    var viewedBannersRef = (0,react.useRef)({});
    var handleBannerView = function(index, banner) {
        gtag/* default.showBannerNewUI */.ZP.showBannerNewUI(banner[index]);
        viewedBannersRef.current[index] = true;
    };
    var handleClickBanner = function(e, item) {
        e.preventDefault();
        gtag/* default.clickBannerNewUI */.ZP.clickBannerNewUI(item);
        router.push(item === null || item === void 0 ? void 0 : item.targetURL);
    };
    var ImageBanner = /*#__PURE__*/ react.forwardRef(function(param, ref) {
        var onClick = param.onClick, data = param.data, href = param.href;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            onClick: onClick,
            ref: ref,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackBanner */.Up, {
                src: data === null || data === void 0 ? void 0 : data.imgURL,
                fallbackSrc: data === null || data === void 0 ? void 0 : data.imgUR,
                width: 1200,
                height: 345,
                objectFit: "cover",
                layout: "fill"
            })
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)((styles_module_default()).boxSlider),
        ref: wrapperRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref3
        }, settingsSliderBanner), {
            afterChange: function(index) {
                if (visible) {
                    handleBannerView(index, infoBanner);
                }
            },
            children: infoBanner.map(function(data) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)((styles_module_default()).gridImagesWrapper),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).gridImages,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).bannerCell,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (data === null || data === void 0 ? void 0 : data.targetURL) || "#",
                                    passHref: true,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBanner, {
                                        data: data,
                                        href: data === null || data === void 0 ? void 0 : data.targetURL,
                                        onClick: function(e) {
                                            return handleClickBanner(e, data);
                                        }
                                    })
                                }),
                                (data === null || data === void 0 ? void 0 : data.showProvinceName) && provinceName && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (styles_module_default()).bannerTextLayer,
                                    "aria-hidden": "true",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (styles_module_default()).provinceOnPill,
                                            children: provinceName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (styles_module_default()).provinceOnNote,
                                            children: provinceName
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }, data === null || data === void 0 ? void 0 : data.imgURL);
            })
        }))
    });
};
/* harmony default export */ var mocules_BannerSliderNew = (/*#__PURE__*/(0,react.memo)(BannerSliderNew));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(11476);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(48999);
// EXTERNAL MODULE: ./src/utils/ImageUtils.tsx
var ImageUtils = __webpack_require__(81989);
// EXTERNAL MODULE: ./src/components-v2/mocules/DrugGroup/styles.module.css
var DrugGroup_styles_module = __webpack_require__(28069);
var DrugGroup_styles_module_default = /*#__PURE__*/__webpack_require__.n(DrugGroup_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/DrugGroup/index.js























var useStyles = (0,makeStyles/* default */.Z)({
    dialog: {
        position: "absolute",
        right: -32,
        top: 0,
        overflowY: "hidden",
        padding: "20px 5px 20px 20px",
        maxWidth: "fit-content",
        maxHeight: "100%",
        marginTop: 0
    }
});
var LightTooltip = (0,styled/* default */.Z)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function() {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "#A2A0A0"
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#A2A0A0",
        color: "#fff",
        fontSize: 12,
        top: "5px"
    }), _obj;
});
var DrugItem = function(param) {
    var item = param.item, handleClick = param.handleClick, index = param.index;
    var onClickItem = function(e) {
        handleClick(e);
        gtag/* default.clickDrugGroup */.ZP.clickDrugGroup(item.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
        "data-index": index,
        onClick: function() {
            return onClickItem(item);
        },
        className: (0,clsx/* default */.Z)((DrugGroup_styles_module_default()).drugContainer, index > 11 && (DrugGroup_styles_module_default()).hiddenM, index > 9 && (DrugGroup_styles_module_default()).hiddenS, index > 7 && (DrugGroup_styles_module_default()).hiddenXs, index > 5 && (DrugGroup_styles_module_default()).hiddenXxs),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackStatic */.ez, {
                src: (0,ImageUtils/* getLinkProxyFile */.GD)(item === null || item === void 0 ? void 0 : item.icon),
                width: 70,
                height: 70,
                alt: "icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (DrugGroup_styles_module_default()).wrapperInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                        title: item === null || item === void 0 ? void 0 : item.name,
                        arrow: true,
                        placement: "top",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (DrugGroup_styles_module_default()).name,
                            children: item === null || item === void 0 ? void 0 : item.name
                        })
                    }),
                    item.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rect",
                        animation: "wave"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: (DrugGroup_styles_module_default()).totalProduct,
                        children: [
                            (item === null || item === void 0 ? void 0 : item.total) || 0,
                            " sản phẩm"
                        ]
                    })
                ]
            })
        ]
    });
};
var SvgIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.006 11.0818C16.5418 11.5767 16.5418 12.4233 16.006 12.9182L11.5982 16.99C10.7976 17.7295 9.5 17.1617 9.5 16.0718V7.92819C9.5 6.83827 10.7976 6.27044 11.5982 7.01L16.006 11.0818Z",
                fill: "#0E1983"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "23",
                height: "23",
                rx: "11.5",
                stroke: "#0E1983"
            })
        ]
    });
};
var SvgClose = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.40912 7.99954L13.7052 3.71279C13.8934 3.52463 13.9991 3.26943 13.9991 3.00333C13.9991 2.73723 13.8934 2.48203 13.7052 2.29387C13.5171 2.10571 13.262 2 12.9959 2C12.7298 2 12.4747 2.10571 12.2865 2.29387L8.00039 6.59061L3.71425 2.29387C3.52612 2.10571 3.27095 2 3.00489 2C2.73883 2 2.48367 2.10571 2.29553 2.29387C2.1074 2.48203 2.00171 2.73723 2.00171 3.00333C2.00171 3.26943 2.1074 3.52463 2.29553 3.71279L6.59166 7.99954L2.29553 12.2863C2.20189 12.3792 2.12756 12.4897 2.07684 12.6115C2.02611 12.7332 2 12.8638 2 12.9957C2 13.1277 2.02611 13.2583 2.07684 13.38C2.12756 13.5018 2.20189 13.6123 2.29553 13.7052C2.38841 13.7989 2.49891 13.8732 2.62066 13.9239C2.74241 13.9747 2.873 14.0008 3.00489 14.0008C3.13679 14.0008 3.26737 13.9747 3.38912 13.9239C3.51087 13.8732 3.62137 13.7989 3.71425 13.7052L8.00039 9.40847L12.2865 13.7052C12.3794 13.7989 12.4899 13.8732 12.6117 13.9239C12.7334 13.9747 12.864 14.0008 12.9959 14.0008C13.1278 14.0008 13.2584 13.9747 13.3801 13.9239C13.5019 13.8732 13.6124 13.7989 13.7052 13.7052C13.7989 13.6123 13.8732 13.5018 13.9239 13.38C13.9747 13.2583 14.0008 13.1277 14.0008 12.9957C14.0008 12.8638 13.9747 12.7332 13.9239 12.6115C13.8732 12.4897 13.7989 12.3792 13.7052 12.2863L9.40912 7.99954Z",
            fill: "#C0C0C0"
        })
    });
};
var DrugGroup = function(param) {
    var categories = param.categories;
    var _data = categories.data, data = _data === void 0 ? [] : _data;
    var classes = useStyles();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), groupDrug = ref[0], setGroupDrug = ref[1];
    var ref1 = (0,react.useState)([]), groupDrugDialog = ref1[0], setGroupDrugDialog = ref1[1];
    var ref2 = (0,react.useState)(false), openModal = ref2[0], setOpenModal = ref2[1];
    (0,react.useEffect)(function() {
        if (data && data.length > 0) {
            var initialCategories = data.map(function(category) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, category), {
                    total: 0,
                    isLoading: true
                });
            });
            setGroupDrug(initialCategories.slice(0, 14));
            setGroupDrugDialog(initialCategories);
            var categoriesCode = data.map(function(item) {
                return item === null || item === void 0 ? void 0 : item.code;
            });
            var fetchData = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var response, _tmp, dataRs, updatedCategories, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,WebServiceClient/* getTotalProductCategories */.c2)((_tmp.body = JSON.stringify({
                                        categories: categoriesCode
                                    }), _tmp))
                                ];
                            case 1:
                                response = _state.sent();
                                dataRs = (0,Clients/* getData */.Yu)(response);
                                updatedCategories = initialCategories.map(function(category) {
                                    var dataR = dataRs.find(function(item) {
                                        return item.categoryCode === category.code;
                                    });
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, category), {
                                        total: dataR ? dataR.total : category.total,
                                        isLoading: false
                                    });
                                });
                                setGroupDrug(updatedCategories.slice(0, 14));
                                setGroupDrugDialog(updatedCategories);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Error fetching API:", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchData() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchData();
        }
    }, [
        data
    ]);
    var onClickItem = function(item) {
        var query = JSON.stringify({
            categoryFilters: [
                {
                    code: item === null || item === void 0 ? void 0 : item.code,
                    categoryCodes: [
                        item === null || item === void 0 ? void 0 : item.code
                    ],
                    efficacyCodes: [],
                    sellerCategoryCodes: []
                }
            ]
        });
        router.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router), {
            pathname: "/products",
            query: {
                filter: query,
                page: 1
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (DrugGroup_styles_module_default()).flexWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "list__drug",
                className: (DrugGroup_styles_module_default()).borderRadius,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (DrugGroup_styles_module_default()).parentContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: (DrugGroup_styles_module_default()).title,
                            children: [
                                "Nh\xf3m sản phẩm",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                                    className: (DrugGroup_styles_module_default()).viewAll,
                                    onClick: function() {
                                        return setOpenModal(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Xem tất cả"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (DrugGroup_styles_module_default()).drugWrapper,
                            children: groupDrug === null || groupDrug === void 0 ? void 0 : groupDrug.map(function(item, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(DrugItem, {
                                    item: item,
                                    handleClick: onClickItem,
                                    index: index
                                }, item === null || item === void 0 ? void 0 : item.code);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: openModal,
                onClose: function() {
                    return setOpenModal(false);
                },
                classes: {
                    paper: classes.dialog
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (DrugGroup_styles_module_default()).flexTitle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (DrugGroup_styles_module_default()).title,
                                    children: "Nh\xf3m sản phẩm"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    onClick: function() {
                                        return setOpenModal(false);
                                    },
                                    className: (DrugGroup_styles_module_default()).fixedIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        className: (DrugGroup_styles_module_default()).close,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Đ\xf3ng"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgClose, {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (DrugGroup_styles_module_default()).drugWrapperModal,
                            children: groupDrugDialog === null || groupDrugDialog === void 0 ? void 0 : groupDrugDialog.map(function(item) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(DrugItem, {
                                    item: item,
                                    handleClick: onClickItem
                                }, item === null || item === void 0 ? void 0 : item.code);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_DrugGroup = (DrugGroup);

// EXTERNAL MODULE: ./src/components-v2/mocules/ModalRating/index.js
var ModalRating = __webpack_require__(36807);
// EXTERNAL MODULE: ./src/clients/MarketingClient.js
var MarketingClient = __webpack_require__(13124);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/services/WebService.js + 1 modules
var WebService = __webpack_require__(98682);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/components-v2/mocules/NanoBanner/styles.module.css
var NanoBanner_styles_module = __webpack_require__(9085);
var NanoBanner_styles_module_default = /*#__PURE__*/__webpack_require__.n(NanoBanner_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/NanoBanner/index.js




















function NanoBanner(param) {
    var dataShowBoxYir = param.dataShowBoxYir;
    var ref;
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref1 = (0,react.useState)([]), bannerNano = ref1[0], setBannerNano = ref1[1];
    var ref2 = (0,react.useState)([]), listCampaign = ref2[0], setListCampaign = ref2[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var fetchData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(user === null || user === void 0 ? void 0 : user.customerID)) return [
                            3,
                            2
                        ];
                        fetchData = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                                var res, _tmp, campaigns, newList;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _tmp = {};
                                            return [
                                                4,
                                                (0,MarketingClient/* getCampaignListV2 */.Ls)((_tmp.q = JSON.stringify({
                                                    platform: "WEB"
                                                }), _tmp.provinceCode = user.provinceCode, _tmp.limit = 20, _tmp))
                                            ];
                                        case 1:
                                            res = _state.sent();
                                            campaigns = (0,Clients/* getData */.Yu)(res);
                                            newList = [];
                                            if (campaigns.length > 3) {
                                                if (dataShowBoxYir && dataShowBoxYir.campaignBoxId) {
                                                    newList = campaigns.filter(function(x) {
                                                        return x.campaignBoxID !== dataShowBoxYir.campaignBoxId;
                                                    });
                                                } else {
                                                    newList = campaigns.slice(0, 3);
                                                }
                                            } else {
                                                newList = campaigns;
                                                if (dataShowBoxYir && dataShowBoxYir.campaignBoxId) {
                                                    newList = campaigns.filter(function(x) {
                                                        return x.campaignBoxID !== dataShowBoxYir.campaignBoxId;
                                                    });
                                                }
                                            }
                                            setListCampaign(newList);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function fetchData() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return [
                            4,
                            fetchData()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        user === null || user === void 0 ? void 0 : user.customerID,
        dataShowBoxYir
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var banners, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(user === null || user === void 0 ? void 0 : user.provinceCode)) return [
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            (0,WebService/* getNanoBanners */.zT)((_tmp.provinceCode = user === null || user === void 0 ? void 0 : user.provinceCode, _tmp.customerID = user === null || user === void 0 ? void 0 : user.customerID, _tmp))
                        ];
                    case 1:
                        banners = _state.sent();
                        setBannerNano(banners);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        user === null || user === void 0 ? void 0 : user.provinceCode,
        user === null || user === void 0 ? void 0 : user.customerID
    ]);
    var nanoRefs = (0,react.useRef)();
    var visible = (0,useOnScreen/* default */.Z)(nanoRefs);
    (0,react.useEffect)(function() {
        if (visible) {
            (0,debounce/* debounceFunc300 */.V9)(function() {
                if (bannerNano.length === 0) return;
                gtag/* default.showNanobanner */.ZP.showNanobanner(bannerNano[0]);
                listCampaign === null || listCampaign === void 0 ? void 0 : listCampaign.forEach(function(item) {
                    gtag/* default.showCampaignbox */.ZP.showCampaignbox(item);
                });
            });
        }
    }, [
        visible,
        bannerNano
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NanoBanner_styles_module_default()).containerBanner,
        ref: nanoRefs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (NanoBanner_styles_module_default()).containerImage,
                children: ((ref = bannerNano[0]) === null || ref === void 0 ? void 0 : ref.imgURL) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBanner, {
                        banner: bannerNano[0]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackStatic */.ez, {
                    src: "".concat("https://cdn-web-next-stg.thuocsi.vn" || 0, "/images/home/nanoBanner.png"),
                    width: 1200,
                    objectFit: "cover",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)((NanoBanner_styles_module_default()).rightContainer, (listCampaign === null || listCampaign === void 0 ? void 0 : listCampaign.length) < 3 && (NanoBanner_styles_module_default()).rightContainerSliderLessThen),
                children: listCampaign === null || listCampaign === void 0 ? void 0 : listCampaign.map(function(x) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Event, {
                            data: x
                        })
                    }, x.campaignBoxID);
                })
            })
        ]
    });
};
function ImageBanner(param) {
    var banner = param.banner;
    var handleClickBannerNano = function handleClickBannerNano(e, item) {
        e.preventDefault();
        gtag/* default.clickNanobanner */.ZP.clickNanobanner(item === null || item === void 0 ? void 0 : item.name, item === null || item === void 0 ? void 0 : item.targetURL);
        router.push(item === null || item === void 0 ? void 0 : item.targetURL);
    };
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: (banner === null || banner === void 0 ? void 0 : banner.targetURL) || "#",
        passHref: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onClick: function(e) {
                return handleClickBannerNano(e, banner);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackBanner */.Up, {
                src: banner === null || banner === void 0 ? void 0 : banner.imgURL,
                width: 1200,
                objectFit: "cover",
                layout: "fill"
            })
        })
    });
}
function Event(param) {
    var data = param.data;
    var router = (0,next_router.useRouter)();
    var handleClick = function(e, item) {
        e.preventDefault();
        gtag/* default.clickCampaignbox */.ZP.clickCampaignbox(item.title, item.url);
        router.push(item.url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: data === null || data === void 0 ? void 0 : data.url,
        passHref: true,
        legacyBehavior: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            onClick: function(e) {
                return handleClick(e, data);
            },
            className: (0,clsx/* default */.Z)((NanoBanner_styles_module_default()).eventContainer),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                    placement: "top",
                    title: (data === null || data === void 0 ? void 0 : data.typeLabel) || "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (NanoBanner_styles_module_default()).titleEvent,
                        children: (data === null || data === void 0 ? void 0 : data.typeLabel) || ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NanoBanner_styles_module_default()).wrapperIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* default */.ZP, {
                        objectFit: "contain",
                        width: "100%",
                        src: data === null || data === void 0 ? void 0 : data.icon,
                        alt: "icon voucher",
                        height: "32"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (NanoBanner_styles_module_default()).wrapperViewMore,
                    children: [
                        (data === null || data === void 0 ? void 0 : data.subTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (NanoBanner_styles_module_default()).wrapperSubTitle,
                            children: data === null || data === void 0 ? void 0 : data.subTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (NanoBanner_styles_module_default()).titleNanoBanner,
                            children: data === null || data === void 0 ? void 0 : data.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: (NanoBanner_styles_module_default()).viewMore,
                            children: [
                                " ",
                                (data === null || data === void 0 ? void 0 : data.cta) || "Xem th\xeam"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components-v2/mocules/OcrFlowContainer/Components/ModalLayout/index.jsx
var ModalLayout = __webpack_require__(78022);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/components-v2/mocules/OcrFlowContainer/Components/ConfirmUI/index.tsx
var ConfirmUI = __webpack_require__(65397);
// EXTERNAL MODULE: ./src/components-v2/mocules/OcrFlowContainer/index.module.css
var index_module = __webpack_require__(45685);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components-v2/mocules/OcrFlowContainer/utils.ts
var utils = __webpack_require__(90055);
;// CONCATENATED MODULE: ./src/components-v2/mocules/OcrFlowContainer/ConfirmContent/ConfirmRemind.tsx
// ConfirmStep.tsx








var ConfirmRemind = function(param) {
    var onClose = param.onClose;
    var classes = (0,clsx/* default */.Z)((index_module_default()).StepContainer, (index_module_default()).confirmClose, (index_module_default()).flexColCenter);
    var handleNextStep = function() {
        window.location.href = utils/* LICENSE_PAGE_URL */.py;
    };
    var onRedirectToHome = function() {
        return onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmUI/* default */.Z, {
        classes: classes,
        buttonNext: utils/* ConfirmText.Close */.Zs.Close,
        buttonClose: "Bỏ qua",
        onNext: handleNextStep,
        onClose: onRedirectToHome,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* OCR_REMIND */.MY4, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "T\xe0i khoản chưa được k\xedch hoạt"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).flexColCenter,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (index_module_default()).flexRow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: (index_module_default()).content,
                        children: [
                            "Bạn cần",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                className: (index_module_default()).strongContent,
                                children: "\xa0x\xe1c thực giấy ph\xe9p\xa0"
                            }),
                            "để được k\xedch hoạt t\xe0i khoản mua h\xe0ng tại thuocsi.vn"
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/home/hooks/useGetMegaBlockConfig.ts






var TIME_CACHE = 900000; // 15 minutes
var MEGA_BLOCK_CACHE_KEY = "MEGA_BLOCK_CONFIG_CACHE_1";
var useGetMegaBlockConfig = function() {
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref = (0,react.useState)(), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(true), loading = ref2[0], setLoading = ref2[1];
    var megaBlockConfigs = (0,react.useMemo)(function() {
        if (!data) return [];
        var position1;
        var position2;
        var hasPosition1 = false;
        var hasPosition2 = false;
        data === null || data === void 0 ? void 0 : data.forEach(function(item) {
            if (item && Array.isArray(item.skuTags) && item.skuTags.length > 0) {
                if ((!item.position || item.position === 1) && !hasPosition1) {
                    position1 = item;
                    hasPosition1 = true;
                }
                if (item.position === 2 && !hasPosition2) {
                    position2 = item;
                    hasPosition2 = true;
                }
            }
        });
        return [
            position1,
            position2
        ];
    }, [
        data
    ]);
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                //set loading
                setLoading(true);
                _tmp = {};
                try {
                    (0,MarketingClient/* getMegaBlockProductConfig */.lX)((_tmp.getUsing = true, _tmp)).then(function(res) {
                        if ((0,Clients/* isValid */.JY)(res)) {
                            setData(res.data);
                        }
                    }, function() {
                        setData([]);
                    });
                } catch (error) {
                    setError(error);
                    console.error(error);
                } finally{
                    // set loading false
                    setLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    // Config phụ thuộc khách đang đăng nhập nên phải gọi lại khi biết khách là ai,
    // không thì giữ nguyên kết quả của lượt gọi ẩn danh lúc mới mount.
    (0,react.useEffect)(function() {
        fetchData();
    }, [
        user === null || user === void 0 ? void 0 : user.customerID
    ]);
    return {
        data: megaBlockConfigs,
        error: error,
        loading: loading
    };
};

// EXTERNAL MODULE: ./src/components/layout/Template/index.js + 8 modules
var Template = __webpack_require__(97394);
// EXTERNAL MODULE: ./src/components/mocules/Skeleton/SliderProductBlock.js
var SliderProductBlock = __webpack_require__(2546);
// EXTERNAL MODULE: ./src/components-v2/mocules/ProductCardLite/index.tsx
var ProductCardLite = __webpack_require__(37876);
// EXTERNAL MODULE: ./src/components/mocules/ListProductWithTitle/index.js + 1 modules
var ListProductWithTitle = __webpack_require__(32838);
// EXTERNAL MODULE: ./src/constants/Enums/app-settings.ts
var app_settings = __webpack_require__(73796);
// EXTERNAL MODULE: ./src/hooks/useGetProductsDisplayedFromAppSettings.ts
var useGetProductsDisplayedFromAppSettings = __webpack_require__(56856);
// EXTERNAL MODULE: ./src/components/organisms/HomePageBlockV2/styles.module.css
var HomePageBlockV2_styles_module = __webpack_require__(20861);
var HomePageBlockV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(HomePageBlockV2_styles_module);
;// CONCATENATED MODULE: ./src/components/organisms/HomePageBlockV2/index.js








function HomePageBlockV2(param) {
    var _type = param.type, type = _type === void 0 ? "" : _type, _redirectUrl = param.redirectUrl, redirectUrl = _redirectUrl === void 0 ? "" : _redirectUrl, _viewMore = param.viewMore, viewMore = _viewMore === void 0 ? true : _viewMore, viewMoreInTitle = param.viewMoreInTitle, _name = param.name, name = _name === void 0 ? "" : _name, icon = param.icon, product = param.product, gap = param.gap, forceShowButtonAtBottom = param.forceShowButtonAtBottom, _blockCodeTracking = param.blockCodeTracking, blockCodeTracking = _blockCodeTracking === void 0 ? "" : _blockCodeTracking, backgroundImage = param.backgroundImage, config = param.config;
    var ref;
    // String 'HOME_CHEAPEST_PRODUCTS' from Web app Config => EnumAppSettings.PRODUCTS_DISPLAYED
    var MAXIMUM_PRODUCT_SHOW = (0,useGetProductsDisplayedFromAppSettings/* useGetProductsDisplayedFromAppSettings */.m)(app_settings/* EnumProductsDisplayedMobile.HOME_CHEAPEST_PRODUCTS */.ds.HOME_CHEAPEST_PRODUCTS);
    var limit = (config === null || config === void 0 ? void 0 : config.limit) || MAXIMUM_PRODUCT_SHOW;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HomePageBlockV2_styles_module_default()).containerPage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductWithTitle/* default */.Z, {
            name: name,
            viewMore: viewMore,
            viewMoreInTitle: viewMoreInTitle,
            redirect: redirectUrl,
            productsType: type,
            icon: icon,
            gap: gap,
            forceShowButtonAtBottom: forceShowButtonAtBottom,
            backgroundImage: backgroundImage,
            config: config,
            children: (ref = product === null || product === void 0 ? void 0 : product.slice(0, limit)) === null || ref === void 0 ? void 0 : ref.map(function(p) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardLite/* default */.Z, {
                    product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                        blockCode: blockCodeTracking
                    })
                }, "item-product-".concat(p.slug));
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/MiniBannerBlock/index.js
var MiniBannerBlock = __webpack_require__(34414);
// EXTERNAL MODULE: ./src/constants/data/guideline/index.tsx + 2 modules
var guideline = __webpack_require__(87225);
// EXTERNAL MODULE: ./src/constants/Images/mobile/index.js
var mobile = __webpack_require__(93893);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/constants/Tags/index.js
var Tags = __webpack_require__(91983);
// EXTERNAL MODULE: ./src/constants/tracking/index.ts + 1 modules
var tracking = __webpack_require__(27429);
// EXTERNAL MODULE: ./src/context/Popup/index.js
var Popup = __webpack_require__(14739);
;// CONCATENATED MODULE: ./src/hooks/useInsiderPopup.js




var LEVEL_OBJECT = {
    LEVEL_SILVER: "Silver",
    LEVEL_GOLD: "Gold",
    LEVEL_DIAMOND: "Diamond",
    LEVEL_PLATINUM: "Platinum"
};
var useInsiderPopup = function(user, insiderUrl, projectId) {
    var ref = (0,react.useState)(false), displayPopup = ref[0], setDisplayPopup = ref[1];
    var ref1 = (0,react.useState)(false), isShowNextPopup = ref1[0], setIsShowNextPopup = ref1[1];
    var getProvinceByCode = (0,useProvinces/* useProvinces */.L)().getProvinceByCode;
    var divRef = (0,react.useRef)(null);
    var scriptRef = (0,react.useRef)(null);
    var urlRef = (0,react.useRef)(null);
    var cancelledRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        cancelledRef.current = false;
        return function() {
            var ref, ref1;
            cancelledRef.current = true;
            (ref = divRef.current) === null || ref === void 0 ? void 0 : ref.remove();
            (ref1 = scriptRef.current) === null || ref1 === void 0 ? void 0 : ref1.remove();
            if (urlRef.current) {
                URL.revokeObjectURL(urlRef.current);
            }
            divRef.current = null;
            scriptRef.current = null;
            urlRef.current = null;
        };
    }, []);
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, province, respFetchScript, _tmp, ref1, scriptText, divInsider, url, scriptEl;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getProvinceByCode(user === null || user === void 0 ? void 0 : user.provinceCode)
                            ];
                        case 1:
                            province = _state.sent();
                            _tmp = {};
                            return [
                                4,
                                fetch(insiderUrl, (_tmp.method = "POST", _tmp.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp.body = JSON.stringify({
                                    uniqueID: user === null || user === void 0 ? void 0 : (ref = user.customerID) === null || ref === void 0 ? void 0 : ref.toString(),
                                    projectID: +projectId,
                                    phoneNumber: user === null || user === void 0 ? void 0 : user.phone,
                                    name: user === null || user === void 0 ? void 0 : user.name,
                                    email: user === null || user === void 0 ? void 0 : user.email,
                                    customAttributes: [
                                        {
                                            key: "thanh_pho",
                                            value: (province === null || province === void 0 ? void 0 : province.name) || ""
                                        },
                                        {
                                            key: "rank",
                                            value: LEVEL_OBJECT[user === null || user === void 0 ? void 0 : user.level]
                                        }, 
                                    ],
                                    platform: "WEB"
                                }), _tmp))
                            ];
                        case 2:
                            respFetchScript = _state.sent();
                            if (!((respFetchScript === null || respFetchScript === void 0 ? void 0 : respFetchScript.status) === 200)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                respFetchScript.text()
                            ];
                        case 3:
                            scriptText = _state.sent();
                            if (cancelledRef.current) {
                                return [
                                    2
                                ];
                            }
                            (ref1 = document.getElementById("buymed-popup")) === null || ref1 === void 0 ? void 0 : ref1.remove();
                            divInsider = document.createElement("div");
                            divInsider.id = "buymed-popup";
                            document.body.appendChild(divInsider);
                            divRef.current = divInsider;
                            url = URL.createObjectURL(new Blob([
                                "(function () {\n".concat(scriptText, "\n})();")
                            ]));
                            scriptEl = document.createElement("script");
                            scriptEl.src = url;
                            document.body.appendChild(scriptEl);
                            scriptRef.current = scriptEl;
                            urlRef.current = url;
                            setTimeout(function() {
                                if (cancelledRef.current) {
                                    return;
                                }
                                // Check if divInsider has child elements
                                var divInsider = document.getElementById("buymed-popup");
                                if (!divInsider || !divInsider.hasChildNodes()) {
                                    setIsShowNextPopup(true);
                                }
                            }, 100);
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (user && displayPopup) {
            fetchData();
        }
    }, [
        user,
        insiderUrl,
        projectId,
        displayPopup
    ]);
    return {
        setDisplayPopup: setDisplayPopup,
        isShowNextPopup: isShowNextPopup
    };
};
/* harmony default export */ var hooks_useInsiderPopup = (useInsiderPopup);

;// CONCATENATED MODULE: ./src/hooks/useOpenOnDateChange.js

var useOpenOnDateChange = function(isRequiredCertificates, isAuthenticated) {
    var ref = (0,react.useState)(null), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), isShowNextPopup = ref1[0], setIsShowNextPopup = ref1[1];
    (0,react.useEffect)(function() {
        if (isAuthenticated && isRequiredCertificates) {
            var now = new Date();
            var todayString = now.toISOString().split("T")[0];
            var lastOpenRemindDate = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("lastOpenRemindDate");
            if (todayString !== lastOpenRemindDate) {
                setOpen(true);
                localStorage.setItem("lastOpenRemindDate", todayString);
                localStorage.setItem("keyToggleOcrPopup", "false");
            } else {
                setIsShowNextPopup(true);
            }
        } else {
            setIsShowNextPopup(true);
        }
    }, [
        isRequiredCertificates,
        isAuthenticated
    ]);
    (0,react.useEffect)(function() {
        if (open === false) {
            setIsShowNextPopup(true);
        }
    }, [
        open
    ]);
    return [
        open,
        function() {
            return setOpen(false);
        },
        isShowNextPopup
    ];
};
/* harmony default export */ var hooks_useOpenOnDateChange = (useOpenOnDateChange);

// EXTERNAL MODULE: ./src/utils/helper.js
var helper = __webpack_require__(46203);
// EXTERNAL MODULE: ./node_modules/@thuocsi/customer-live-chat/dist/bundle.js
var bundle = __webpack_require__(69665);
// EXTERNAL MODULE: ./src/utils/SessionUtils.js
var SessionUtils = __webpack_require__(69702);
;// CONCATENATED MODULE: ./src/utils/LiveChat.js






var LiveChat = function(param) {
    var liveStreamID = param.liveStreamID;
    var protocolWS = "wss";
    var ref = (0,react.useState)(null), accessToken = ref[0], setAccessToken = ref[1];
    var ref1 = (0,Auth/* useAuth */.aC)(), auth = ref1.auth, refreshKey = ref1.refreshKey;
    (0,react.useEffect)(function() {
        var sessionToken = (0,SessionUtils/* getSessionTokenClient */.c)();
        if (!sessionToken) {
            setAccessToken(auth);
        } else {
            setAccessToken(sessionToken);
        }
    }, [
        auth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bundle/* GroupChat */.S, {
            apiChatUrl: "/backend",
            websocketChatUrl: "".concat(protocolWS, "://").concat(sysconfig/* API_CHAT_DOMAIN */.Wn, "/integration/chat/v1/web-socket"),
            isShowLog: true,
            handleAppError: function() {},
            accessToken: accessToken,
            liveStreamID: liveStreamID
        }, refreshKey)
    });
};
/* harmony default export */ var utils_LiveChat = (LiveChat);

// EXTERNAL MODULE: ./src/utils/MonitorUtils.js
var MonitorUtils = __webpack_require__(31459);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/home/HomeUser.module.css
var HomeUser_module = __webpack_require__(3592);
var HomeUser_module_default = /*#__PURE__*/__webpack_require__.n(HomeUser_module);
// EXTERNAL MODULE: ./src/clients/ProductClientV2.js
var ProductClientV2 = __webpack_require__(22997);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/home/hooks/useGetBlockProducts.ts





var useGetBlockProducts = function(param) {
    var megaBlockConfigs = param.megaBlockConfigs;
    var ref = (0,react.useState)([]), blockProducts = ref[0], setBlockProducts = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var query = (0,react.useMemo)(function() {
        if (!megaBlockConfigs || !megaBlockConfigs.length) return undefined;
        return megaBlockConfigs.map(function(item, index) {
            return {
                index: index + 1,
                tags: item === null || item === void 0 ? void 0 : item.skuTags
            };
        });
    }, [
        megaBlockConfigs
    ]);
    (0,react.useEffect)(function() {
        if (!query) return;
        setIsLoading(true);
        (0,ProductClientV2/* getFeaturedProductGroups */.m3)({
            productGroups: (0,_to_consumable_array/* default */.Z)(query).concat([
                {
                    index: megaBlockConfigs.length + 1,
                    tags: [
                        Tags/* PRODUCT_TAG.SANPHAMMOI */.d.SANPHAMMOI
                    ]
                }, 
            ])
        }).then(function(res) {
            if ((0,Clients/* isValid */.JY)(res)) {
                var data = res.data;
                setBlockProducts(data);
            }
        }).finally(function() {
            setIsLoading(false);
        });
    }, [
        query
    ]);
    return {
        data: blockProducts,
        isLoading: isLoading
    };
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/home/HomeUser.jsx















































var Partners = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4569).then(__webpack_require__.bind(__webpack_require__, 94569));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94569)
            ];
        }
    },
    ssr: false
});
var CustomerSayAbout = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9502).then(__webpack_require__.bind(__webpack_require__, 69502));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69502)
            ];
        }
    },
    ssr: false
});
var LiveStream = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5372), __webpack_require__.e(8192)]).then(__webpack_require__.bind(__webpack_require__, 18192));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18192)
            ];
        }
    },
    ssr: false
});
var PopupTourRSLoyaltyPoint = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 960).then(__webpack_require__.bind(__webpack_require__, 80960));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80960)
            ];
        }
    },
    ssr: false
});
var HomeProductRecommendationBlock = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9019).then(__webpack_require__.bind(__webpack_require__, 25146));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25146)
            ];
        }
    },
    ssr: false
});
var ImageIconGoodPrice = function() {
    return /*#__PURE__*/ _jsx(ImageFallback, {
        src: "".concat("https://cdn-web-next-stg.thuocsi.vn" || 0, "/images/iconV2/medical_drug.png"),
        width: 40,
        height: 40
    });
};
var INIT_LIVE = {
    isLive: false,
    url: "",
    liveStreamID: null,
    chatVisible: true,
    hiddenLive: false,
    roomID: "",
    startTimeShifting: ""
};
var SIZE_ICON = 40;
function PCScreen(param) {
    var _bannerStatus = param.bannerStatus, bannerStatus = _bannerStatus === void 0 ? null : _bannerStatus, _featuredProductGroups = param.featuredProductGroups, featuredProductGroups = _featuredProductGroups === void 0 ? [] : _featuredProductGroups, loading = param.loading, _categories = param.categories, categories = _categories === void 0 ? [] : _categories, dataShowBoxYir = param.dataShowBoxYir, atLeastLoyaltyPoint = param.atLeastLoyaltyPoint, loyaltyRSPoint = param.loyaltyRSPoint, isPopupRSLoyaltyPoints = param.isPopupRSLoyaltyPoints, togglePopupRSLoyaltyPoints = param.togglePopupRSLoyaltyPoints, _isOnMovingPromoCode = param.isOnMovingPromoCode, isOnMovingPromoCode = _isOnMovingPromoCode === void 0 ? false : _isOnMovingPromoCode, toggleMovingPromoCode = param.toggleMovingPromoCode, user = param.user, _isShowNextPopup = param.isShowNextPopup, isShowNextPopup = _isShowNextPopup === void 0 ? false : _isShowNextPopup, _megaBlockConfigs = param.megaBlockConfigs, megaBlockConfigs = _megaBlockConfigs === void 0 ? [] : _megaBlockConfigs;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)({
        SIEU_RE: [],
        THUOCKEDONGIATOT: [],
        BANCHAY: [],
        NEW: [],
        DEAL: []
    }), productData = ref3[0], setProductData = ref3[1];
    var ref4 = (0,react.useState)(), openRating = ref4[0], setOpenRating = ref4[1];
    var ref5 = (0,react.useState)(INIT_LIVE), mediaLive = ref5[0], setMediaLive = ref5[1];
    var mediaLiveRef = (0,react.useRef)(INIT_LIVE);
    var appSetting = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.appSetting;
    });
    var ref6 = (0,_sliced_to_array/* default */.Z)(megaBlockConfigs.map(function(item) {
        try {
            var ref, ref1, ref2, ref3, ref4;
            if (!item) return null;
            var background = (0,common/* getImageProxy */.Sh)(item.backgroundImageUrl) || (appSetting === null || appSetting === void 0 ? void 0 : (ref = appSetting.HOME_PRODUCTS_BLOCK_CONFIG) === null || ref === void 0 ? void 0 : (ref1 = ref.RE_NHAT) === null || ref1 === void 0 ? void 0 : ref1.backgroundImageDesktop) || "/images/home/BG2.png";
            var ctaLink = item.ctaStatus ? item.ctaUrl : (appSetting === null || appSetting === void 0 ? void 0 : (ref2 = appSetting.HOME_PRODUCTS_BLOCK_CONFIG) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.RE_NHAT) === null || ref3 === void 0 ? void 0 : ref3.url) || "/products";
            var ctaText = item.ctaStatus ? item.ctaText : "Xem tất cả";
            var backgroundCta = item.ctaStatus ? item.ctaBackgroundColor : undefined;
            var ctaTextColor = item.ctaStatus ? item.ctaTextColor : undefined;
            var displayMegaBlockCta = item.ctaStatus;
            var tag = item.skuTags[0];
            return {
                name: item.name,
                background: background,
                ctaLink: ctaLink,
                ctaText: ctaText,
                backgroundCta: backgroundCta,
                ctaTextColor: ctaTextColor,
                displayMegaBlockCta: displayMegaBlockCta,
                headerImageUrl: item.headerImageUrl,
                limit: item.limit,
                tag: tag,
                products: ((ref4 = featuredProductGroups.find(function(o) {
                    var ref;
                    return (ref = o.tags) === null || ref === void 0 ? void 0 : ref.includes(tag);
                })) === null || ref4 === void 0 ? void 0 : ref4.products) || []
            };
        } catch (e) {
            console.error("Error in megaBlockConfig:", e);
            return null;
        }
    }), 2), megaBlockConfigTop = ref6[0], megaBlockConfigBottom = ref6[1];
    var timeIntervalMediaLive = null;
    (0,react.useEffect)(function() {
        var productDataMap = new Map();
        featuredProductGroups.forEach(function(param) {
            var tags = param.tags, products = param.products;
            tags === null || tags === void 0 ? void 0 : tags.forEach(function(tag) {
                var currentSet = productDataMap.get(tag) || new Set();
                products === null || products === void 0 ? void 0 : products.forEach(function(product) {
                    return currentSet.add(product);
                });
                productDataMap.set(tag, currentSet);
            });
        });
        productDataMap.forEach(function(productSet, tag) {
            productDataMap.set(tag, Array.from(productSet));
        });
        var ref, ref1, ref2, ref3, ref4;
        setProductData(function(prevProductData) {
            var ref5;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevProductData), {
                SIEU_RE: (0,_to_consumable_array/* default */.Z)((ref = productDataMap.get(Tags/* PRODUCT_TAG.SIEU_RE */.d.SIEU_RE)) !== null && ref !== void 0 ? ref : []),
                THUOCKEDONGIATOT: (0,_to_consumable_array/* default */.Z)((ref1 = productDataMap.get(Tags/* PRODUCT_TAG.NHAN_DOI_TICH_LUY */.d.NHAN_DOI_TICH_LUY)) !== null && ref1 !== void 0 ? ref1 : []),
                BANCHAY: (0,_to_consumable_array/* default */.Z)((ref2 = productDataMap.get(Tags/* PRODUCT_TAG.BANCHAY */.d.BANCHAY)) !== null && ref2 !== void 0 ? ref2 : []),
                NEW: (0,_to_consumable_array/* default */.Z)((ref3 = productDataMap.get(Tags/* PRODUCT_TAG.SANPHAMMOI */.d.SANPHAMMOI)) !== null && ref3 !== void 0 ? ref3 : []),
                DEAL: (0,_to_consumable_array/* default */.Z)((ref4 = (ref5 = featuredProductGroups[4]) === null || ref5 === void 0 ? void 0 : ref5.products) !== null && ref4 !== void 0 ? ref4 : [])
            });
        });
    }, [
        featuredProductGroups
    ]);
    (0,react.useEffect)(function() {
        var timeRatingLocal = localStorage.getItem("time-rating");
        if (timeRatingLocal) {
            var ref, ref1, ref2;
            var calculateDateShowRating = (0,helper/* calculateTwoDates */.Zx)(timeRatingLocal);
            var timeHiddenRating = (user === null || user === void 0 ? void 0 : (ref = user.customerRatingConfig) === null || ref === void 0 ? void 0 : ref.durationGapMinutes) ? (user === null || user === void 0 ? void 0 : (ref1 = user.customerRatingConfig) === null || ref1 === void 0 ? void 0 : ref1.durationGapMinutes) / 60 / 24 : 1;
            if (calculateDateShowRating > timeHiddenRating && (user === null || user === void 0 ? void 0 : (ref2 = user.customerRatingConfig) === null || ref2 === void 0 ? void 0 : ref2.showRatingPopup)) {
                setOpenRating(true);
            }
        } else {
            var ref3;
            setOpenRating(user === null || user === void 0 ? void 0 : (ref3 = user.customerRatingConfig) === null || ref3 === void 0 ? void 0 : ref3.showRatingPopup);
        }
    }, []);
    var setMediaState = function(data) {
        var mediaHistory = mediaLiveRef.current;
        var stateData = {
            isLive: mediaHistory.isLive,
            url: mediaHistory === null || mediaHistory === void 0 ? void 0 : mediaHistory.url,
            roomID: mediaHistory === null || mediaHistory === void 0 ? void 0 : mediaHistory.roomID,
            liveStreamID: mediaHistory === null || mediaHistory === void 0 ? void 0 : mediaHistory.liveStreamID,
            startTimeShifting: mediaHistory === null || mediaHistory === void 0 ? void 0 : mediaHistory.startTimeShifting
        };
        var compareData = {
            isLive: data.isLive,
            url: data === null || data === void 0 ? void 0 : data.url,
            roomID: data === null || data === void 0 ? void 0 : data.roomID,
            liveStreamID: data === null || data === void 0 ? void 0 : data.liveStreamID,
            startTimeShifting: data === null || data === void 0 ? void 0 : data.startTimeShifting
        };
        if (JSON.stringify(stateData) !== JSON.stringify(compareData)) {
            mediaLiveRef.current = compareData;
            setMediaLive(function(curr) {
                return (0,_object_spread/* default */.Z)({}, curr, data);
            });
        }
    };
    var onLiveListener = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, data, response, mediaLiveData, _tmp, metaData, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            VideoClient/* default.getCurrentLiveStream */.Z.getCurrentLiveStream()
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,Clients/* isValid */.JY)(result)) {
                            setMediaState(INIT_LIVE);
                            return [
                                2
                            ];
                        }
                        data = (0,Clients/* getData */.Yu)(result);
                        _tmp = {};
                        _tmp1 = {};
                        if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                            response = data[0];
                            if (mediaLiveRef.current.liveStreamID === (response === null || response === void 0 ? void 0 : response.liveStreamID) || !mediaLiveRef.current.liveStreamID) {
                                mediaLiveData = (_tmp.isLive = true, _tmp.url = response === null || response === void 0 ? void 0 : response.hlsUrl, _tmp.roomID = response === null || response === void 0 ? void 0 : response.roomID, _tmp.liveStreamID = response === null || response === void 0 ? void 0 : response.liveStreamID, _tmp.startTimeShifting = response === null || response === void 0 ? void 0 : response.startTimeShifting, _tmp);
                                setMediaState(mediaLiveData);
                                metaData = (_tmp1.liveStreamID = response === null || response === void 0 ? void 0 : response.liveStreamID, _tmp1);
                                MonitorUtils/* default.sendLivestreamEvent */.ZP.sendLivestreamEvent(MonitorUtils/* MONITORING_COLLECTOR_TYPE.DISPLAY_LIVESTREAM */.Hq.DISPLAY_LIVESTREAM, metaData);
                            }
                        } else {
                            setMediaState(INIT_LIVE);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onLiveListener() {
            return _ref.apply(this, arguments);
        };
    }();
    var getCurrentViewLiveStream = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, liveStreamID, result, _tmp, currentView;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        liveStreamID = (ref = mediaLiveRef.current) === null || ref === void 0 ? void 0 : ref.liveStreamID;
                        if (!liveStreamID) return [
                            2,
                            0
                        ];
                        _tmp = {};
                        return [
                            4,
                            VideoClient/* default.getViewCurrentLive */.Z.getViewCurrentLive((_tmp.liveStreamID = liveStreamID, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        currentView = (ref1 = result.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.currentView;
                        if (currentView) {
                            return [
                                2,
                                currentView
                            ];
                        }
                        return [
                            2,
                            0
                        ];
                }
            });
        });
        return function getCurrentViewLiveStream() {
            return _ref.apply(this, arguments);
        };
    }();
    var onView = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, liveStreamID, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        liveStreamID = (ref = mediaLiveRef.current) === null || ref === void 0 ? void 0 : ref.liveStreamID;
                        if (!liveStreamID) return [
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            VideoClient/* default.reportView */.Z.reportView((_tmp.liveStreamID = liveStreamID, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onView() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        onLiveListener();
        timeIntervalMediaLive = setInterval(function() {
            onLiveListener();
        }, 60000);
        return function() {
            clearInterval(timeIntervalMediaLive);
        };
    }, []);
    // tracking monitor
    var trackingMonitorClientClickChangingPointGuide = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var event, metaData, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                event = MonitorUtils/* MONITORING_COLLECTOR_TYPE.CLICK_CHANGING_POINT_GUIDE */.Hq.CLICK_CHANGING_POINT_GUIDE;
                _tmp = {};
                metaData = (_tmp.customerId = String(user === null || user === void 0 ? void 0 : user.customerID), _tmp.source = "web-desktop", _tmp.screen = (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname), _tmp.description = "Click n\xfat “Đổi điểm” trong popup guide điểm t\xedch lũy", _tmp);
                MonitorUtils/* default.rsLoyaltyPointClickEvent */.ZP.rsLoyaltyPointClickEvent(event, metaData);
                return [
                    2
                ];
            });
        });
        return function trackingMonitorClientClickChangingPointGuide() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmRSLoyaltyPoint = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _isConfirm, isConfirm, feature, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _isConfirm = param.isConfirm, isConfirm = _isConfirm === void 0 ? false : _isConfirm;
                        feature = guideline/* GUIDE_FEATURE.NOTI_RESET_POINT */.Z.NOTI_RESET_POINT;
                        _tmp = {};
                        return [
                            4,
                            (0,CustomerClient/* postUserLogGuide */.n)((_tmp.feature = feature, _tmp.isViewAll = isConfirm, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        _tmp1 = {};
                        if (isConfirm) {
                            toggleMovingPromoCode(true);
                            trackingMonitorClientClickChangingPointGuide();
                            router.push((_tmp1.pathname = Paths/* PROMO_CODES */.Q2, _tmp1.query = {
                                isScroll: true
                            }, _tmp1));
                        } else {
                            togglePopupRSLoyaltyPoints(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmRSLoyaltyPoint(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            mediaLive.isLive && mediaLive.url && mediaLive.liveStreamID && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                className: (HomeUser_module_default()).boxChatContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveStream, {
                    onCount: getCurrentViewLiveStream,
                    onView: onView,
                    urlPull: mediaLive.url,
                    chat: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_LiveChat, {
                        liveStreamID: mediaLive === null || mediaLive === void 0 ? void 0 : mediaLive.liveStreamID
                    }),
                    startTime: mediaLive.startTimeShifting
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-6 pt-6 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        className: "container px-0 relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 7,
                                children: bannerStatus === "ON" && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_BannerSliderNew, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NanoBanner, {
                                    dataShowBoxYir: dataShowBoxYir
                                })
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProductBlock/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProductBlock/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProductBlock/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProductBlock/* default */.Z, {})
                        ]
                    }),
                    (megaBlockConfigTop === null || megaBlockConfigTop === void 0 ? void 0 : (ref = megaBlockConfigTop.products) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageBlockV2, {
                        name: " ",
                        blockCodeTracking: tracking/* EnumBlockCodeTracking.HOME_MEGA_BLOCK.replace */.x.HOME_MEGA_BLOCK.replace("<blockName>", (megaBlockConfigTop === null || megaBlockConfigTop === void 0 ? void 0 : megaBlockConfigTop.name) || tracking/* EnumTrackingStatic.MEGA_BLOCK */.X.MEGA_BLOCK),
                        viewMore: megaBlockConfigTop.displayMegaBlockCta,
                        redirectUrl: megaBlockConfigTop.ctaLink,
                        type: "MEGA-SALE",
                        // icon={<ImageFallback src={HOME_ICON_MEGA_SALE} width={40} height={40} />}
                        product: megaBlockConfigTop.products,
                        gap: "15px",
                        config: {
                            ctaText: megaBlockConfigTop.ctaText,
                            backgroundCta: megaBlockConfigTop.backgroundCta,
                            ctaTextColor: megaBlockConfigTop.ctaTextColor,
                            headerImage: megaBlockConfigTop === null || megaBlockConfigTop === void 0 ? void 0 : megaBlockConfigTop.headerImageUrl,
                            limit: megaBlockConfigTop === null || megaBlockConfigTop === void 0 ? void 0 : megaBlockConfigTop.limit
                        },
                        backgroundImage: megaBlockConfigTop.background
                    }),
                    categories.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProductBlock/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_DrugGroup, {
                        categories: categories
                    }),
                    (megaBlockConfigBottom === null || megaBlockConfigBottom === void 0 ? void 0 : (ref1 = megaBlockConfigBottom.products) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageBlockV2, {
                        name: " ",
                        blockCodeTracking: tracking/* EnumBlockCodeTracking.HOME_MEGA_BLOCK.replace */.x.HOME_MEGA_BLOCK.replace("<blockName>", (megaBlockConfigBottom === null || megaBlockConfigBottom === void 0 ? void 0 : megaBlockConfigBottom.name) || tracking/* EnumTrackingStatic.MEGA_BLOCK */.X.MEGA_BLOCK),
                        viewMore: megaBlockConfigBottom.displayMegaBlockCta,
                        redirectUrl: megaBlockConfigBottom.ctaLink,
                        type: "MEGA-SALE",
                        // icon={<ImageFallback src={HOME_ICON_MEGA_SALE} width={40} height={40} />}
                        product: megaBlockConfigBottom.products,
                        gap: "15px",
                        config: {
                            ctaText: megaBlockConfigBottom.ctaText,
                            backgroundCta: megaBlockConfigBottom.backgroundCta,
                            ctaTextColor: megaBlockConfigBottom.ctaTextColor,
                            headerImage: megaBlockConfigBottom === null || megaBlockConfigBottom === void 0 ? void 0 : megaBlockConfigBottom.headerImageUrl,
                            limit: megaBlockConfigBottom === null || megaBlockConfigBottom === void 0 ? void 0 : megaBlockConfigBottom.limit
                        },
                        backgroundImage: megaBlockConfigBottom.background
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniBannerBlock/* default */.Z, {}),
                    ((ref2 = productData.NEW) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageBlockV2, {
                        name: "Sản phẩm mới",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* default */.ZP, {
                            src: mobile/* NEW_PRODUCT */.Ny,
                            width: SIZE_ICON,
                            height: SIZE_ICON
                        }),
                        type: sysconfig/* TAG_NEW */.cC,
                        redirectUrl: "/products?currentTab=san-pham-moi&tag=".concat(Tags/* PRODUCT_TAG.SANPHAMMOI */.d.SANPHAMMOI, "&page=1&sort=NEWEST"),
                        product: productData.NEW,
                        viewMoreInTitle: false,
                        forceShowButtonAtBottom: true,
                        blockCodeTracking: tracking/* EnumBlockCodeTracking.HOME_NEW_PRODUCTS */.x.HOME_NEW_PRODUCTS
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProductRecommendationBlock, {
                viewMoreInTitle: false,
                showBtnAllAtBottom: true,
                blockCodeTracking: tracking/* EnumBlockCodeTracking.HOME_JFY */.x.HOME_JFY
            }),
            !isPopupRSLoyaltyPoints && (user === null || user === void 0 ? void 0 : user.customerRatingConfig) && isShowNextPopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalRating/* default */.Z, {
                open: openRating,
                onClose: function() {
                    return setOpenRating(false);
                },
                configData: user
            }) : null,
            loyaltyRSPoint > 0 && isPopupRSLoyaltyPoints ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupTourRSLoyaltyPoint, {
                open: isPopupRSLoyaltyPoints,
                handleConfirm: function() {
                    return handleConfirmRSLoyaltyPoint({
                        isConfirm: true
                    });
                },
                handleClose: function() {
                    return handleConfirmRSLoyaltyPoint({
                        isConfirm: false
                    });
                },
                loyaltyRsPoint: loyaltyRSPoint,
                isMoving: isOnMovingPromoCode,
                atLeastLoyaltyPoint: atLeastLoyaltyPoint
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners, {
                isLogin: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSayAbout, {
                isLogin: true
            })
        ]
    });
}
function HomeUser(param) {
    var pageName = param.pageName, pageTitle = param.pageTitle, bannerStatus = param.bannerStatus, insiderUrl = param.insiderUrl, projectId = param.projectId;
    var router = (0,next_router.useRouter)();
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref = (0,_sliced_to_array/* default */.Z)(hooks_useOpenOnDateChange(user === null || user === void 0 ? void 0 : user.isRequiredCertificates, true), 2), isOpen = ref[0], handleClose = ref[1];
    var toggleFeature = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.toggleFeature;
    });
    var toggleBeta = (0,storeMobile/* default */.Z)(function(state) {
        return state.toggleBeta;
    });
    var ref1 = (0,react.useState)({
        data: [],
        isLoading: false
    }), categories = ref1[0], setCategories = ref1[1];
    var ref2 = (0,react.useState)(), dataYir = ref2[0], setDataYir = ref2[1];
    var ref3 = (0,react.useState)(false), isShowGuide = ref3[0], setIsShowGuide = ref3[1];
    var ref4 = (0,react.useState)(), dataShowBoxYir = ref4[0], setDataShowBoxYir = ref4[1];
    // res loyalty point
    var ref5 = (0,react.useState)(), rsLoyaltyPoint = ref5[0], setRsLoyaltyPoint = ref5[1];
    var ref6 = (0,react.useState)(0), atLeastLoyaltyPoint = ref6[0], setAtLeastLoyaltyPoint = ref6[1];
    var ref7 = (0,react.useState)(true), isPopupRSLoyaltyPoints = ref7[0], togglePopupRSLoyaltyPoints = ref7[1]; // set true for first priority guide
    var ref8 = (0,react.useState)(false), isOnMovingPromoCode = ref8[0], toggleMovingPromoCode = ref8[1];
    // handle check remind popup if user chưa có giấy phép
    var ref9 = hooks_useInsiderPopup(user, insiderUrl, projectId), setDisplayPopup = ref9.setDisplayPopup, isShowNextPopup = ref9.isShowNextPopup;
    var canShowNextPopup = (0,Popup/* usePopup */.B)().canShowNextPopup;
    var ref10 = useGetMegaBlockConfig(), megaBlockConfigs = ref10.data;
    var ref11 = useGetBlockProducts({
        megaBlockConfigs: megaBlockConfigs
    }), featuredProductGroups = ref11.data, isLoadingBlockProducts = ref11.isLoading;
    var ref12 = router || {}, _query = ref12.query, _trial = _query.trial, trial = _trial === void 0 ? false : _trial, chatTs = _query.chatTs;
    var fetchDataCategories = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var categoriesRes, _tmp, _tmp1, data, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setCategories(function(previousState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousState), {
                                isLoading: true
                            });
                        });
                        _tmp = {};
                        return [
                            4,
                            (0,WebServiceClient/* getCategories */.CP)(_tmp)
                        ];
                    case 1:
                        categoriesRes = _state.sent();
                        _tmp1 = {};
                        if (!(0,Clients/* isValid */.JY)(categoriesRes)) {
                            setCategories((_tmp1.data = [], _tmp1.isLoading = false, _tmp1));
                            return [
                                2
                            ];
                        }
                        data = (0,Clients/* getData */.Yu)(categoriesRes);
                        _tmp2 = {};
                        setCategories((_tmp2.data = data, _tmp2.isLoading = false, _tmp2));
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchDataCategories() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (trial) {
            toggleBeta();
        }
    }, [
        trial
    ]);
    (0,react.useEffect)(function() {
        // Don't display insider popup when there is already a popup opened
        if (!canShowNextPopup) {
            return setDisplayPopup(false);
        }
        var lastOpenRemindDate = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("lastOpenRemindDate");
        var keyToggleOcrPopup = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("keyToggleOcrPopup");
        if ((user === null || user === void 0 ? void 0 : user.isRequiredCertificates) && keyToggleOcrPopup === "true") {
            var dateToCompare = lastOpenRemindDate;
            var todayString = new Date().toISOString().split("T")[0];
            if (dateToCompare === todayString) {
                return setDisplayPopup(true);
            }
        } else {
            localStorage.setItem("keyToggleOcrPopup", "true");
        }
        if (!(user === null || user === void 0 ? void 0 : user.isRequiredCertificates)) {
            return setDisplayPopup(true);
        }
        return null;
    }, [
        user,
        canShowNextPopup
    ]);
    (0,react.useEffect)(function() {
        if (isShowNextPopup) {
            setIsShowGuide(true);
        }
    }, [
        isShowNextPopup
    ]);
    (0,react.useEffect)(function() {
        if (chatTs != null) toggleFeature("chatTs", chatTs, {
            isCookie: true
        });
    }, [
        chatTs
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var query, getYearInReview, _tmp, ref, ref1, ref2, ref3, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        query = router.query;
                        if (!(query === null || query === void 0 ? void 0 : query.yearreview)) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            getYearInReview(_tmp)
                        ];
                    case 1:
                        getYearInReview = _state.sent();
                        _tmp1 = {};
                        _tmp2 = {};
                        if ((0,Clients/* isValid */.JY)(getYearInReview)) {
                            setDataYir(getYearInReview);
                            setIsShowGuide(false);
                        } else {
                            ;
                            setDataShowBoxYir((_tmp1.campaignBoxId = (getYearInReview === null || getYearInReview === void 0 ? void 0 : (ref = getYearInReview.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.webMobileCampaignBoxID) || "", _tmp1));
                            localStorage.setItem("finishYir", JSON.stringify((_tmp2.isFinish = true, _tmp2.notFound = true, _tmp2.customerID = user === null || user === void 0 ? void 0 : user.customerID, _tmp2.campaignBoxId = getYearInReview === null || getYearInReview === void 0 ? void 0 : (ref2 = getYearInReview.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.webMobileCampaignBoxID, _tmp2)));
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router
    ]);
    // guide reset Loyalty point
    (0,react.useEffect)(function() {
        fetchDataCategories();
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, respListLoyalty, respRsLoyaltyPoint, respCheckGuideRSPoint, _tmp, atLeastLoyaltyPoint, dataCheckGuide, condRsLoyaltyPoint;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            Promise.all([
                                (0,PromoClient/* getSelfLoyaltyList */.Fn)(),
                                (0,CustomerClient/* getUserResetLoyaltyPoint */.be)(),
                                (0,CustomerClient/* getUserLogGuide */.Xd)((_tmp.q = {
                                    feature: guideline/* GUIDE_FEATURE.NOTI_RESET_POINT */.Z.NOTI_RESET_POINT
                                }, _tmp))
                            ])
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            3
                        ]), respListLoyalty = ref[0], respRsLoyaltyPoint = ref[1], respCheckGuideRSPoint = ref[2];
                        // get rs loyalty point
                        if ((respRsLoyaltyPoint === null || respRsLoyaltyPoint === void 0 ? void 0 : respRsLoyaltyPoint.status) === "OK") {
                            setRsLoyaltyPoint((0,Clients/* getFirst */.Xi)(respRsLoyaltyPoint) || 0);
                        } else {
                            setRsLoyaltyPoint(0);
                        }
                        // get minimum loyalty point on list
                        if ((respListLoyalty === null || respListLoyalty === void 0 ? void 0 : respListLoyalty.status) === "OK") {
                            atLeastLoyaltyPoint = Math.min.apply(0, (0,Clients/* getData */.Yu)(respListLoyalty).map(function(item) {
                                return item === null || item === void 0 ? void 0 : item.point;
                            }));
                            setAtLeastLoyaltyPoint(atLeastLoyaltyPoint || 0);
                        } else {
                            setAtLeastLoyaltyPoint(0);
                        }
                        dataCheckGuide = (0,Clients/* getFirst */.Xi)(respCheckGuideRSPoint);
                        condRsLoyaltyPoint = respRsLoyaltyPoint && (0,Clients/* getFirst */.Xi)(respRsLoyaltyPoint) > 0;
                        if ((dataCheckGuide === null || dataCheckGuide === void 0 ? void 0 : dataCheckGuide.isActive) && !(dataCheckGuide === null || dataCheckGuide === void 0 ? void 0 : dataCheckGuide.isGuided) && condRsLoyaltyPoint) {
                            togglePopupRSLoyaltyPoints(true);
                        } else {
                            togglePopupRSLoyaltyPoints(false);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Template/* default */.Z, {
        pageName: pageName,
        pageTitle: pageTitle,
        showTopSearchMV2: true,
        isWelcomeBack: user === null || user === void 0 ? void 0 : user.isWelcomeBack,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PCScreen, {
                categories: categories,
                bannerStatus: bannerStatus,
                provinceCode: user === null || user === void 0 ? void 0 : user.provinceCode,
                featuredProductGroups: featuredProductGroups,
                loading: isLoadingBlockProducts,
                dataYir: dataYir,
                isShowGuide: isShowGuide,
                dataShowBoxYir: dataShowBoxYir,
                atLeastLoyaltyPoint: atLeastLoyaltyPoint,
                loyaltyRSPoint: rsLoyaltyPoint,
                isPopupRSLoyaltyPoints: isPopupRSLoyaltyPoints,
                togglePopupRSLoyaltyPoints: togglePopupRSLoyaltyPoints,
                isOnMovingPromoCode: isOnMovingPromoCode,
                toggleMovingPromoCode: toggleMovingPromoCode,
                megaBlockConfigs: megaBlockConfigs,
                user: user,
                isShowNextPopup: isShowNextPopup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalLayout/* default */.Z, {
                visible: isOpen,
                onClose: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                    fullWidth: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmRemind, {
                        onClose: handleClose
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/home/index.js






// Must use direct import
// When using dynamic import, when redirect from /ingredients to /home, the CSS for Template is removed, causing missing CSS issue.
// Ref: https://github.com/vercel/next.js/issues/17464

var HomeGuest = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3998), __webpack_require__.e(1703), __webpack_require__.e(6787), __webpack_require__.e(2704), __webpack_require__.e(120)]).then(__webpack_require__.bind(__webpack_require__, 60120));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60120)
            ];
        }
    },
    ssr: false
});
var pageName = "home";
var pageTitle = "Trang chủ";
var bannerStatus = "ON";
function HomePage(props) {
    return sysconfig/* IS_UI */.mR && !props.isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeGuest, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        pageName: pageName,
        pageTitle: pageTitle,
        showTopSearchMV2: true,
        bannerStatus: bannerStatus
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeUser, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        pageName: pageName,
        pageTitle: pageTitle,
        bannerStatus: bannerStatus
    }));
}
var __N_SSP = true;
/* harmony default export */ var home = ((0,HOC/* withLogin */.U)(HomePage, false));


/***/ }),

/***/ 68373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36902);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38597);




var INITIAL_STATE = {
    isGuide: 0
};
var useStartGuide = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, INITIAL_STATE), {
        setGuide: function(payload) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, get()), {
                isGuide: payload
            }));
        }
    });
}, {
    name: "guide_state"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useStartGuide);


/***/ }),

/***/ 79820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boxSlider":"styles_boxSlider__SGqPR","gridImagesWrapper":"styles_gridImagesWrapper__NOV7V","gridImages":"styles_gridImages__CARVb","bannerCell":"styles_bannerCell__9utaT","bannerTextLayer":"styles_bannerTextLayer__r4OUY","provinceOnPill":"styles_provinceOnPill__4OILz","provinceOnNote":"styles_provinceOnNote__EFjVR","dots":"styles_dots__M8L6h","fullWidth":"styles_fullWidth__7WGZZ","slick-thumb":"styles_slick-thumb__oUyRV"};

/***/ }),

/***/ 28069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"styles_flexWrapper__no71p","parentContainer":"styles_parentContainer__AFmUF","flexItem":"styles_flexItem___lCAG","title":"styles_title___NB_z","drugWrapper":"styles_drugWrapper__ty7XO","drugWrapperModal":"styles_drugWrapperModal__xI0H7","drugContainer":"styles_drugContainer__ObZ6i","viewAll":"styles_viewAll__1if2W","name":"styles_name__mSTrZ","totalProduct":"styles_totalProduct__Uve9g","flexTitleContainer":"styles_flexTitleContainer__Jthrm","flexTitle":"styles_flexTitle__X04AS","close":"styles_close__XIrpm","fixedIcon":"styles_fixedIcon__RJ_iY","wrapperInfo":"styles_wrapperInfo__u4SvA","borderRadius":"styles_borderRadius___plyA","hiddenM":"styles_hiddenM__2qTuL","hiddenS":"styles_hiddenS__z_EOO","hiddenXs":"styles_hiddenXs__lcVIm","hiddenXxs":"styles_hiddenXxs__s6z0d"};

/***/ }),

/***/ 50645:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__B4UPq","containerModal":"styles_containerModal__HOZVM","title":"styles_title__mi6cN","body":"styles_body__AY8L1","titleBody":"styles_titleBody__8ilGg","textarea":"styles_textarea__rByT_","ratingContainer":"styles_ratingContainer__ZzjXI","wrapperImage":"styles_wrapperImage__05FGF","groupButton":"styles_groupButton__Hb2uB","disabled":"styles_disabled__rubf9","submit":"styles_submit__iK9w7","skipButton":"styles_skipButton__g2iWe","error":"styles_error__bgpjX","errorMessage":"styles_errorMessage__7xDnm"};

/***/ }),

/***/ 9085:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerBanner":"styles_containerBanner__ccxQt","containerImage":"styles_containerImage__16_rE","rightContainer":"styles_rightContainer__sEBgg","rightContainerSliderLessThen":"styles_rightContainerSliderLessThen__KuhAr","eventContainer":"styles_eventContainer__BTLwM","titleNanoBanner":"styles_titleNanoBanner__SXAKI","titleEvent":"styles_titleEvent__sd5f9","wrapperIcon":"styles_wrapperIcon__pmkaE","viewMore":"styles_viewMore__tuVoe","wrapperSlide":"styles_wrapperSlide__pYQj1","wrapperViewMore":"styles_wrapperViewMore__jnsAw","wrapperSubTitle":"styles_wrapperSubTitle__gpwEk","link":"styles_link__vU_4X"};

/***/ }),

/***/ 26205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ConfirmUI":"ConfirmUI_ConfirmUI__VH1hY","accountCreationForm_button":"ConfirmUI_accountCreationForm_button__2YTUn","btnOutlined":"ConfirmUI_btnOutlined__lTVvX"};

/***/ }),

/***/ 69467:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"auth_modal_content":"styles_auth_modal_content__JNIt1","auth_modal_title":"styles_auth_modal_title__QCQhe","isModalRegister":"styles_isModalRegister__TVmMa","auth_modal_close":"styles_auth_modal_close__t8P_L","auth_modal_body":"styles_auth_modal_body__7b6bX","auth_modal_header":"styles_auth_modal_header__4CGWi","form_control":"styles_form_control__Uxmn3"};

/***/ }),

/***/ 45685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"StepContainer":"OcrFlowContainer_StepContainer__IhN4L","AttachContent":"OcrFlowContainer_AttachContent__DbHCk","Gpp":"OcrFlowContainer_Gpp__A9EZn","LicensesUI":"OcrFlowContainer_LicensesUI__5yUca","backgroundUrl":"OcrFlowContainer_backgroundUrl__fJKTR","SuccessVariant":"OcrFlowContainer_SuccessVariant__YAzaq","ModalLayout":"OcrFlowContainer_ModalLayout__su_mu","ButtonBack":"OcrFlowContainer_ButtonBack__3z_Il","StrongText":"OcrFlowContainer_StrongText__cdhgI","btnOutlined":"OcrFlowContainer_btnOutlined__qliFZ","accountCreationForm_button":"OcrFlowContainer_accountCreationForm_button__b28G3","preparationContent":"OcrFlowContainer_preparationContent__QkU2A","title":"OcrFlowContainer_title__rXNi_","flexColCenter":"OcrFlowContainer_flexColCenter__HbCJZ","Established":"OcrFlowContainer_Established__mxZWb","primaryText":"OcrFlowContainer_primaryText__332Ge","body":"OcrFlowContainer_body__XzH8R","flexWrapper":"OcrFlowContainer_flexWrapper__L1YFD","imageWrapper":"OcrFlowContainer_imageWrapper__NofpW","flexRow":"OcrFlowContainer_flexRow__rd7AL","content":"OcrFlowContainer_content___TE8R","strongContent":"OcrFlowContainer_strongContent__2GUle","confirmClose":"OcrFlowContainer_confirmClose__oWZ1K","Selection":"OcrFlowContainer_Selection__2fWhz","zoomIn":"OcrFlowContainer_zoomIn__1E56K","ButtonSubmitStyle":"OcrFlowContainer_ButtonSubmitStyle__Sxt5Z","SelectorFlex":"OcrFlowContainer_SelectorFlex__mf5yG","item":"OcrFlowContainer_item__RtRHU","Certificates":"OcrFlowContainer_Certificates__6aH_p","active":"OcrFlowContainer_active__MmL_y","error":"OcrFlowContainer_error__8dXeQ","date_input":"OcrFlowContainer_date_input__T1_EW","ErrorWrapper":"OcrFlowContainer_ErrorWrapper__yRrF7","isDisabledDropZone":"OcrFlowContainer_isDisabledDropZone__vbJiv","Success":"OcrFlowContainer_Success__QeINh","BodyContent":"OcrFlowContainer_BodyContent__oXuVH","Countdown":"OcrFlowContainer_Countdown__zbsl7","Location":"OcrFlowContainer_Location__VM6fs"};

/***/ }),

/***/ 3592:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"HomeUser_boxContainer__UUGAp","boxVideo":"HomeUser_boxVideo__xF9CE","boxVideoMobile":"HomeUser_boxVideoMobile__VRtw3","containerBanner":"HomeUser_containerBanner__AX9pu","boxChatContainer":"HomeUser_boxChatContainer__hsRy_","boxChat":"HomeUser_boxChat__fhopa","boxChatMobile":"HomeUser_boxChatMobile__dtA4g","title":"HomeUser_title__CES78","boxTitle":"HomeUser_boxTitle__JlgpJ","boxVideoMobileBytePlus":"HomeUser_boxVideoMobileBytePlus__i65Kd","boxVideoBytePlus":"HomeUser_boxVideoBytePlus__oduqE","frameVideo":"HomeUser_frameVideo__1GgVl","frameVideoInner":"HomeUser_frameVideoInner__s3k8E","frameVideoToolbar":"HomeUser_frameVideoToolbar__gQWp_","frameVideoLoading":"HomeUser_frameVideoLoading__Gg11h","itemVolume":"HomeUser_itemVolume__8zjMp","itemIcon":"HomeUser_itemIcon__IXMlc","itemValue":"HomeUser_itemValue__5a_Th"};

/***/ }),

/***/ 99867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__MGuNV","bestProducts":"styles_bestProducts__0ZKaG","title":"styles_title__W7HFl","root":"styles_root__Ko_37","media":"styles_media__RMmSH","large":"styles_large__tQqRx","card_header":"styles_card_header__M6wzK","header_customer":"styles_header_customer__sPI7u","header_title":"styles_header_title__kAY7K","wrapper_media":"styles_wrapper_media__8E69V","wrapper_media_container":"styles_wrapper_media_container__mzr38","card_content":"styles_card_content__n_NFr","comment_style":"styles_comment_style__GopNa","rotate":"styles_rotate__ssmGf","quote":"styles_quote__bZeC9","seeAllWrapper":"styles_seeAllWrapper__LVbbZ","seeAll":"styles_seeAll__R2mnW","seeAllWrapperMega":"styles_seeAllWrapperMega__AU7jy","SliderProductWrap":"styles_SliderProductWrap__FM9kz","SliderProductWrapV2":"styles_SliderProductWrapV2__RpSUD","header":"styles_header__LQMML","name":"styles_name__PAY0o","bestProductsName":"styles_bestProductsName__VOjDx","seeAllMobile":"styles_seeAllMobile___Q7i7","view_more":"styles_view_more__oP_PL","wrapper":"styles_wrapper__Be83M","bestProductsWrapper":"styles_bestProductsWrapper__p8dax","bestProducts_view_more":"styles_bestProducts_view_more__W5FqA","icon_name":"styles_icon_name__GN52V","wrapper_mv2":"styles_wrapper_mv2__ulLGw","view_more_mv2":"styles_view_more_mv2__UVFkx","icon_name_mv2":"styles_icon_name_mv2__xYYvS","name_mv2":"styles_name_mv2__oWnUQ","megaSale_name":"styles_megaSale_name__hNJNF","megaSaleSlider":"styles_megaSaleSlider__l3M54","wrapper_media_mobile":"styles_wrapper_media_mobile__OCWC8","wrapper_media_mobile_container":"styles_wrapper_media_mobile_container__pDaaq","wrapperContentTitle":"styles_wrapperContentTitle__AGJR6","contentTitle":"styles_contentTitle__y8kvU","contentTitleTop":"styles_contentTitleTop__YJVee","backgroundMega":"styles_backgroundMega__aCiLv","wrapperMega":"styles_wrapperMega__BIzkZ","wrapperTitle":"styles_wrapperTitle__DaSRf","backgroundTitle":"styles_backgroundTitle__0oI4D","sliderContainer":"styles_sliderContainer__IjY4Y","removeAddingSpace":"styles_removeAddingSpace__tys5e"};

/***/ }),

/***/ 26123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleSliderProduct":"styles_titleSliderProduct__T2fWl","productCardSkeleton":"styles_productCardSkeleton__rrHkJ","buttonSliderProductSkeleton":"styles_buttonSliderProductSkeleton__Q8a4a","sliderProductBlockWrapper":"styles_sliderProductBlockWrapper__nMGrY","sliderWrapper":"styles_sliderWrapper__UuWW0"};

/***/ }),

/***/ 20861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerPage":"styles_containerPage__DGxQp","productGuideContainer":"styles_productGuideContainer__QO00v","productGuideNotMega":"styles_productGuideNotMega__jQ6iN","displayNone":"styles_displayNone__3AYI7"};

/***/ }),

/***/ 5178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gridImagesWrapper":"styles_gridImagesWrapper__C5NLi","gridImages":"styles_gridImages__AfRal","miniBannerImageSize4_1":"styles_miniBannerImageSize4_1__ohXmv","miniBannerImageSize4_2":"styles_miniBannerImageSize4_2__T3yZS","miniBannerImageSize4_3":"styles_miniBannerImageSize4_3__OP7YU","miniBannerImageSize4_4":"styles_miniBannerImageSize4_4__mO1uG","miniBannerImageSize5_1":"styles_miniBannerImageSize5_1__aqKou","miniBannerImageSize5_2":"styles_miniBannerImageSize5_2__f8AYi","miniBannerImageSize5_3":"styles_miniBannerImageSize5_3__9v5vW","miniBannerImageSize5_4":"styles_miniBannerImageSize5_4__6hDEr","miniBannerImageSize5_5":"styles_miniBannerImageSize5_5__aOt3D","mobileBlock1":"styles_mobileBlock1__t1jfW","mobileBlock2":"styles_mobileBlock2__Ie_li","miniBannerMobileBlock_1":"styles_miniBannerMobileBlock_1__YkN0t","miniBannerMobileBlock_2":"styles_miniBannerMobileBlock_2__Pr0Po","miniBannerMobileBlock_3":"styles_miniBannerMobileBlock_3__gytPf","miniBannerMobileBlock_4":"styles_miniBannerMobileBlock_4__37smp","isBannerSize4":"styles_isBannerSize4__ydhr7","miniBannerMobileBlock_5":"styles_miniBannerMobileBlock_5__GYBh1","miniBannerBlockWrapper":"styles_miniBannerBlockWrapper__FcCrm","gridImagesWrappr":"styles_gridImagesWrappr__Rku4b"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5900,3091,9803,9583,9037,1588,5648,6066,3536,4547,2510,3432,746,7394,9774,2888,179], function() { return __webpack_exec__(38862); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);